(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4011);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; },
  "formatCompanySuggestions": function() { return /* binding */ formatCompanySuggestions; },
  "updateInput": function() { return /* binding */ updateInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/main.js + 317 modules
var main = __webpack_require__(705);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/interfaces/context/appContextInterfaces.ts
var appContextInterfaces = __webpack_require__(4182);
// EXTERNAL MODULE: ./src/utils/tracking.tsx + 3 modules
var tracking = __webpack_require__(6548);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
;// CONCATENATED MODULE: ./src/utils/strings.ts



/**
 * Convert a word to proper Case.
 */ var titleWordCase = function(txt) {
    return "".concat(txt.charAt(0).toUpperCase()).concat(txt.substr(1).toLowerCase());
};
/**
 * Convert a sentence to proper Case.
 */ var titleCase = function(txt) {
    return txt.split(" ").map(titleWordCase).join(" ");
};
/**
 * Converts a diacritic to normalized character plus accent. Then removes the accent.
 */ var normalizeAccents = function(txt) {
    return txt.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
/**
 * Convert number to string and add a comma for thousands and millions.
 */ var formatNumberComma = function(value) {
    return new Intl.NumberFormat("en-US").format(value);
};
/**
 * generate the canonical URL.
 */ var getCanonicalUrl = function() {
    var asPath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/";
    var preface = "https://www.themuse.com";
    var path = asPath.split("?")[0];
    return preface + path;
};
/**
 * Returns true for "true", "True", "TRUE" and "1".
 * @param string string
 * @returns boolean
 */ var strings_isTruthy = function(string) {
    return /^(true|1)$/.test(string.toLowerCase());
};
var parsePath = function(urlPath) {
    return urlPath.replace(/^\/(search\/)?/, "").split("/").reduce(function(values, pathPart, index, shortenedPath) {
        var localValues = values;
        if (index % 2) {
            localValues[shortenedPath[index - 1]] = pathPart;
        } else {
            localValues[pathPart] = "";
        }
        return localValues;
    }, {});
};
/**
 *  Rename the object names to query param names
 */ var objToQueryParams = function(obj) {
    var mappedObj = Object.keys(obj).reduce(function(acc, key) {
        return _object_spread({}, acc, _define_property({}, key, encodeURIComponent(obj[key])));
    }, {});
    var queryParamStr = Object.keys(mappedObj).filter(function(key) {
        if (mappedObj[key] && mappedObj[key].length > 0) {
            return key;
        }
        return null;
    }).map(function(key) {
        return "".concat(key, "/").concat(mappedObj[key] || "");
    }).join("/");
    return queryParamStr;
};
/**
 * Convert the query string into an object
 */ var queryStringToObj = function(searchString) {
    var pairs = searchString.split("&");
    var result = {};
    pairs.forEach(function(pair) {
        var pairSplit = pair.split("=");
        if (pairSplit[0] in result) {
            // check for additional values and add it to the result[key]
            var splitValues = result[pairSplit[0]].split(",");
            splitValues.push(decodeURIComponent(pairSplit[1]));
            result[pairSplit[0]] = splitValues.join(",");
        } else {
            result[pairSplit[0]] = decodeURIComponent(pairSplit[1] || "");
        }
    });
    return result;
};
/**
 * Convert an object to query string removing nulls.
 */ var objToQueryString = function(obj) {
    return Object.keys(obj).map(function(key) {
        return "".concat(key, "=").concat(obj[key] || "");
    }).join("&");
};
/**
 * Remove special characters and reduce to lower case with hyphens.
 */ var slugify = function(text) {
    return decodeURIComponent(text).replace(/[^a-z0-9]/gmi, "-").replace(/--/gmi, "-").toLowerCase();
};
/**
 * Formats a date in correct format for job card
 */ var formatDate = function(date) {
    var month = months[date.getMonth()];
    var day = date.getDate();
    return "".concat(month, " ").concat(day);
};
function camelToSnakeCase(text) {
    return text.replace(/(.)([A-Z][a-z]+)/, "$1_$2").replace(/([a-z0-9])([A-Z])/, "$1_$2").toLowerCase();
}
/**
 * Converts an id number to a string
 */ var getId = function(id) {
    return id ? parseInt(id, 10) : undefined;
};


// EXTERNAL MODULE: ./src/utils/api.ts + 2 modules
var api = __webpack_require__(9909);
// EXTERNAL MODULE: ./src/hooks/AppContext.tsx + 4 modules
var AppContext = __webpack_require__(3863);
;// CONCATENATED MODULE: ./src/hooks/useSessionStorage.tsx


var useSessionStorage = function(key) {
    if (!(0,browser/* isBrowser */.jU)()) {
        return [
            null,
            function() {}
        ];
    }
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var ref = (0,react.useState)(function() {
        return(// Get from session storage by key
        window.sessionStorage.getItem(key));
    }), storedValue = ref[0], setStoredValue = ref[1];
    // Return a wrapped version of useState's setter function that
    // persists the new value to sessionStorage.
    var setValue = function(value) {
        // Save state
        setStoredValue(value);
        // Save to session storage
        window.sessionStorage.setItem(key, value);
    };
    return [
        storedValue,
        setValue
    ];
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(4924);
;// CONCATENATED MODULE: ./src/utils/featureFlags.ts





/**
 * Take a name and determine if the feature flag is activated
 * based on environment variable and query params.
 */ var isFeatureFlagActive = function(name, query, config) {
    if (name in query) {
        return isTruthy(query[name]);
    }
    if ((config === null || config === void 0 ? void 0 : config[name]) !== undefined) {
        return (config === null || config === void 0 ? void 0 : config[name]) === true || (config === null || config === void 0 ? void 0 : config[name]) === "true";
    }
    return false;
};
/**
 * Returns a list of all existing flags in the config.
 */ var getFeatureFlags = function() {
    var publicRuntimeConfig = (0,config["default"])().publicRuntimeConfig;
    return Object.keys(publicRuntimeConfig).reduce(function(prev, curr) {
        if (/^FEATURE_FLAG/.test(curr)) {
            prev.push(curr);
        }
        return prev;
    }, []);
};
/**
 * Returns all active flags in the config and/or query params.
 */ var getActiveFeatureFlags = function(context) {
    var query = context.query;
    var publicRuntimeConfig = getConfig().publicRuntimeConfig;
    var featureFlagsInQuery = getFeatureFlags().reduce(function(featureFlags, featureFlag) {
        return _object_spread_props(_object_spread({}, featureFlags), _define_property({}, featureFlag, isFeatureFlagActive(featureFlag, query, publicRuntimeConfig)));
    }, {});
    return featureFlagsInQuery;
};


;// CONCATENATED MODULE: ./src/hooks/FeatureFlagsContext.tsx






var defaultFeatureFlagsState = Object.keys(getFeatureFlags()).reduce(function(featureFlags, featureFlag) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, featureFlags), (0,src_define_property/* default */.Z)({}, featureFlag, false));
}, {});
var FeatureFlagsContext = /*#__PURE__*/ react.createContext(defaultFeatureFlagsState);
var FeatureFlagsProvider = function(props) {
    var featureFlags = props.featureFlags, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};
var useFeatureFlagsState = function() {
    var context = react.useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error("useFeatureFlagsState must be used within the FeatureFlagsProvider");
    }
    return context;
};
FeatureFlagsProvider.displayName = "FeatureFlagsProvider";
useFeatureFlagsState.displayName = "useFeatureFlagsState";


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/components/AppPageLayout.tsx




/* eslint-disable camelcase */ 


var AppPageLayout = function(props) {
    var children = props.children, restProps = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    var user = (0,AppContext/* useAppState */.mr)().user;
    var pageProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, restProps), {
        user: user
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* PageLayout */.Xg, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pageProps), {
        children: children
    }));
};


// EXTERNAL MODULE: ./src/styles/common.module.scss
var common_module = __webpack_require__(30);
var common_module_default = /*#__PURE__*/__webpack_require__.n(common_module);
// EXTERNAL MODULE: ./src/components/articleHeader.module.scss
var articleHeader_module = __webpack_require__(6874);
var articleHeader_module_default = /*#__PURE__*/__webpack_require__.n(articleHeader_module);
;// CONCATENATED MODULE: ./src/components/ArticleHeader.tsx




var ArticleBreadcrumbLinks = function(props) {
    var crumbs = props.crumbs, articleTitle = props.articleTitle;
    var linkStyle = "".concat((articleHeader_module_default()).breadCrumbLink, " ").concat((common_module_default()).callToAction);
    var cleanCrumbs = crumbs.filter(function(x) {
        return x.title && x.title !== articleTitle;
    });
    var crumbsLength = cleanCrumbs.length - 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: cleanCrumbs.map(function(x, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/".concat(x.uri),
                        className: linkStyle,
                        children: x.title
                    }),
                    i < crumbsLength ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: linkStyle,
                        children: " / "
                    }) : null
                ]
            }, x.title);
        })
    });
};
var ArticleHeader = function(param) {
    var articleTitle = param.articleTitle, breadcrumbs = param.breadcrumbs;
    var crumbs = breadcrumbs.filter(function(x) {
        return x.title !== articleTitle;
    }).map(function(x) {
        return /^advice$/i.test(x.uri) ? {
            title: "Advice",
            uri: "advice"
        } : x;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (articleHeader_module_default()).articleHeader,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (articleHeader_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleBreadcrumbLinks, {
                    crumbs: crumbs,
                    articleTitle: articleTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: (articleHeader_module_default()).title,
                    children: articleTitle
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/SVGIconPinterestBox.tsx

/* eslint-disable max-len */ 
var SVGIconPinterestBox = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 243 243",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "121.5",
                cy: "121.5",
                r: "121.5"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M121.5,0C54.4,0,0,54.4,0,121.5C0,173,32,217,77.2,234.7c-1.1-9.6-2-24.4,0.4-34.9 c2.2-9.5,14.2-60.4,14.2-60.4s-3.6-7.3-3.6-18c0-16.9,9.8-29.5,22-29.5c10.4,0,15.4,7.8,15.4,17.1c0,10.4-6.6,26-10.1,40.5 c-2.9,12.1,6.1,22,18,22c21.6,0,38.2-22.8,38.2-55.6c0-29.1-20.9-49.4-50.8-49.4c-34.6,0-54.9,25.9-54.9,52.7 c0,10.4,4,21.6,9,27.7c1,1.2,1.1,2.3,0.8,3.5c-0.9,3.8-3,12.1-3.4,13.8c-0.5,2.2-1.8,2.7-4.1,1.6c-15.2-7.1-24.7-29.2-24.7-47.1 c0-38.3,27.8-73.5,80.3-73.5c42.1,0,74.9,30,74.9,70.2c0,41.9-26.4,75.6-63,75.6c-12.3,0-23.9-6.4-27.8-14c0,0-6.1,23.2-7.6,28.9 c-2.7,10.6-10.1,23.8-15.1,31.9c11.4,3.5,23.4,5.4,36,5.4c67.1,0,121.5-54.4,121.5-121.5C243,54.4,188.6,0,121.5,0z"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
;// CONCATENATED MODULE: ./src/components/RichTextModule.tsx


var RichTextModule = function(props) {
    var className = props.className, richText = props.richText;
    // eslint-disable-next-line react/no-danger
    return richText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        dangerouslySetInnerHTML: {
            __html: richText
        }
    }) : null;
};


// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/utils/jwPlayer.ts









var JWPLAYER_API_URL = "//cdn.jwplayer.com/v2/media/";
var TRACKED_PLAYBACK_MILESTONES = [
    25,
    50,
    75,
    100
];
var getJWPlayerVideoInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(mediaID) {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return axios_default().get("".concat(JWPLAYER_API_URL).concat(mediaID));
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error("Unable to fetch playlist info from JWPlayer API.", JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    })));
                case 10:
                    return _ctx.abrupt("return", null);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function getJWPlayerVideoInfo(mediaID) {
        return _ref.apply(this, arguments);
    };
}();
var initJWPlayerVideo = function(param) {
    var container = param.container, videoInfo = param.videoInfo, autostart = param.autostart, mute = param.mute, generateSEOMetadata = param.generateSEOMetadata;
    var playlist = videoInfo.playlist;
    if (typeof jwplayer !== "undefined") {
        return jwplayer(container.current).setup({
            playlist: playlist,
            autostart: autostart,
            mute: mute,
            generateSEOMetadata: generateSEOMetadata
        });
    }
    return null;
};
var initJWPlayerTracking = function(props) {
    var playerInstance = props.playerInstance, videoInfo = props.videoInfo, position = props.position, element = props.element;
    Object.assign(window, {
        playerInstance: playerInstance
    });
    var config = playerInstance.getConfig();
    // only the first play is played, everything else is resumed.
    var started = false;
    var firstView = false;
    var getEventProps = function() {
        var result = {
            jw_video_source: position || null,
            jw_video_id: null,
            jw_video_name: videoInfo.title || null,
            jw_video_provider_key: config.id.replace("jwplayer-", "") || null,
            jw_video_provider_name: "jwplayer",
            jw_video_description: videoInfo.description || null,
            jw_video_autoplay: config.autostart || null,
            jw_video_muted: !!playerInstance.getMute(),
            jw_video_position: jwplayer().getPosition()
        };
        return result;
    };
    playerInstance.on("viewable", function() {
        // The viewable event is bugged, so we add a getViewable check
        if (!firstView && playerInstance.getViewable()) {
            (0,build/* triggerSnowplowImpressionEvent */.XQ)(element);
            firstView = true;
        }
    });
    playerInstance.on("play", function() {
        var eventName = started ? "jwPlayerResumed" : "jwPlayerPlayed";
        (0,tracking/* pushDataLayerEvent */.Jt)(eventName, getEventProps());
        started = true;
        (0,build/* triggerSnowplowVideoEvent */.GF)("play", element);
    });
    playerInstance.on("pause", function() {
        return (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayedPaused", getEventProps());
    });
    playerInstance.on("mute", function(event) {
        if (event.mute) {
            (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerMuted", getEventProps());
        } else {
            (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerUnmuted", getEventProps());
        }
    });
    playerInstance.on("fullscreen", function() {
        var fullscreen = playerInstance.getFullscreen();
        var dataLayerProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getEventProps()), {
            jw_video_fullscreen: fullscreen,
            interaction_type: fullscreen ? "enter fullscreen" : "exit fullscreen"
        });
        (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerInteraction", dataLayerProps);
    });
    playerInstance.on("autostartNotAllowed", function() {
        return (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerAutostartNotAllowed", getEventProps());
    });
    playerInstance.on("seek", function(event) {
        var dataLayerProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            jw_video_seek_begin: event.position,
            jw_video_seek_end: event.offset
        }, getEventProps()), {
            interaction_type: event.position > event.offset ? "rewind" : "forward"
        });
        (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerInteraction", dataLayerProps);
    });
    playerInstance.on("time", function(event) {
        var instance = playerInstance;
        var videoPercentComplete = event.position / event.duration * 100;
        TRACKED_PLAYBACK_MILESTONES.forEach(function(milestone) {
            var latestSeen = instance.latestPercentComplete || 0;
            if (videoPercentComplete >= milestone && milestone >= latestSeen) {
                (0,tracking/* pushDataLayerEvent */.Jt)("jwPlayerPlaybackMilestoneReached", (0,src_object_spread/* default */.Z)({
                    video_percent_complete: milestone
                }, getEventProps()));
            }
        });
        instance.latestPercentComplete = videoPercentComplete;
    });
};

;// CONCATENATED MODULE: ./src/components/JWVideoModule.tsx








var videoInit = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(mediaId, ref) {
        var autostart, setVideoInfo, // eslint-disable-next-line no-undef
        setPlayerInstance, videoInfo, instance, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    autostart = _args.length > 2 && _args[2] !== void 0 ? _args[2] : false, setVideoInfo = _args.length > 3 ? _args[3] : void 0, setPlayerInstance = _args.length > 4 ? _args[4] : void 0;
                    if (!mediaId) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 4;
                    return getJWPlayerVideoInfo(mediaId);
                case 4:
                    _ctx.t0 = _ctx.sent;
                    _ctx.next = 8;
                    break;
                case 7:
                    _ctx.t0 = null;
                case 8:
                    videoInfo = _ctx.t0;
                    setVideoInfo(videoInfo);
                    if (videoInfo !== null) {
                        instance = initJWPlayerVideo({
                            videoInfo: videoInfo,
                            autostart: autostart,
                            container: ref,
                            mute: !!autostart,
                            generateSEOMetadata: false // We don't seem to use this
                        });
                        setPlayerInstance(instance);
                    }
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function videoInit(mediaId, ref) {
        return _ref.apply(this, arguments);
    };
}();
var JWVideoModule = function(param) {
    var jwVideo = param.jwVideo, richText = param.richText, heading = param.heading, _autostart = param.autostart, autostart = _autostart === void 0 ? false : _autostart, _position = param.position, position = _position === void 0 ? "post_individual_body" : _position;
    var jwPlayerContainer = (0,react.useRef)(null);
    var jwPlayerWrapper = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), videoInfo = ref[0], setVideoInfo = ref[1];
    var ref1 = (0,react.useState)(null), playerInstance = ref1[0], setPlayerInstance = ref1[1];
    var ref2 = (0,react.useState)(null), trackingProps = ref2[0], setTrackingProps = ref2[1];
    // Get the video info, then init the player instance.
    (0,react.useEffect)(function() {
        videoInit(jwVideo, jwPlayerContainer, autostart, setVideoInfo, setPlayerInstance);
    }, []);
    // Init tracking props if the player was successfully instantiated.
    (0,react.useEffect)(function() {
        if (videoInfo && playerInstance) {
            setTrackingProps({
                "data-tracking-props": JSON.stringify({
                    sp_impression_component: "insert",
                    sp_impression_insert_type: "media",
                    sp_impression_position: "in_article",
                    sp_media_type: "video",
                    sp_media_name: (videoInfo === null || videoInfo === void 0 ? void 0 : videoInfo.title) || null,
                    sp_media_provider_key: jwVideo || null,
                    sp_media_provider_name: "jwplayer"
                })
            });
        }
    }, [
        videoInfo,
        playerInstance
    ]);
    // Init tracking if tracking props are available.
    (0,react.useEffect)(function() {
        if (trackingProps) {
            initJWPlayerTracking({
                playerInstance: playerInstance,
                videoInfo: videoInfo,
                position: position,
                element: jwPlayerWrapper === null || jwPlayerWrapper === void 0 ? void 0 : jwPlayerWrapper.current
            });
        }
    }, [
        trackingProps
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: "jwplayerModule"
    }, trackingProps), {
        ref: jwPlayerWrapper,
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "jwplayer-".concat(jwVideo),
                className: "jwplayer-container",
                ref: jwPlayerContainer
            }),
            richText && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
                type: "richTextBlock",
                richText: richText
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/Link.tsx





/**
 * Remove all starting urls that contain themuse.com/
 * We include the trailing slash to exclude instances where the string
 * is url encoded such as within social media.
 */ var convertUriToRelativeUrl = function(url) {
    var relativeUrl = url.split("themuse.com/").pop();
    if (!relativeUrl.startsWith("http") && !relativeUrl.startsWith("/")) {
        relativeUrl = "/".concat(relativeUrl);
    }
    return relativeUrl;
};
var Link = function(_param) {
    var children = _param.children, href = _param.href, rel = _param.rel, target = _param.target, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href",
        "rel",
        "target"
    ]);
    var url = convertUriToRelativeUrl(href);
    var targetProps = {
        target: target || url.startsWith("http") ? "_blank" : null,
        rel: rel || url.startsWith("http") ? "noopener noreferrer" : null
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        href: url
    }, targetProps, restProps), {
        children: children
    }));
};
/**
 * Creates an anchor <a> element.
 * * Ensures that all urls pointing to themuse are relative
 * * Ensures that relative urls begin with a slash, forcing them to the root.
 * * Adds noopener and noreferer to external links if they do not already have a rel.
 */ 

// EXTERNAL MODULE: ./src/components/leadMedia.module.scss
var leadMedia_module = __webpack_require__(1111);
var leadMedia_module_default = /*#__PURE__*/__webpack_require__.n(leadMedia_module);
// EXTERNAL MODULE: ./src/components/responsiveImageModule.module.scss
var responsiveImageModule_module = __webpack_require__(1536);
var responsiveImageModule_module_default = /*#__PURE__*/__webpack_require__.n(responsiveImageModule_module);
;// CONCATENATED MODULE: ./src/components/Caption.tsx






var Citation = function(props) {
    var credit = props.credit, creditLink = props.creditLink;
    return credit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("cite", {
        children: creditLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
            href: creditLink,
            target: "_blank",
            children: credit
        }) : credit
    }) : null;
};
var Caption = function(props) {
    var caption = props.caption, credit = props.credit, creditLink = props.creditLink;
    var Cite = /*#__PURE__*/ (0,jsx_runtime.jsx)(Citation, {
        credit: credit,
        creditLink: creditLink
    });
    var Cap = /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
        type: undefined,
        className: undefined,
        richText: caption
    });
    return Cite || caption ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
        className: "".concat((leadMedia_module_default()).caption, " ").concat((responsiveImageModule_module_default()).caption),
        children: [
            Cap,
            credit && caption ? " | " : "",
            Cite
        ]
    }) : null;
};


// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(7563);
;// CONCATENATED MODULE: ./src/utils/pilbox.ts




var IMAGE_FILE_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".gif",
    ".png"
];
var stripTrailingSlash = function(input) {
    return input.endsWith("/") ? input.slice(0, -1) : input;
};
var genPilboxURL = function() {
    var pilboxHost = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", imageUrl = arguments.length > 1 ? arguments[1] : void 0, options = arguments.length > 2 ? arguments[2] : void 0;
    // default quality of 90 as pilbox default is 50
    // eslint-disable-next-line no-param-reassign
    options.q = options.q || 90;
    var currentExtension = IMAGE_FILE_EXTENSIONS.find(function(extension) {
        return imageUrl.toLowerCase().includes(extension);
    }) || "";
    var queryParams = (0,src_object_spread/* default */.Z)({
        url: imageUrl
    }, Object.keys(options).reduce(function(result, key) {
        if (options[key] === undefined) {
            return result;
        }
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, result), (0,src_define_property/* default */.Z)({}, key, options[key]));
    }, {}));
    return "".concat(stripTrailingSlash(pilboxHost), "/image").concat(currentExtension, "?").concat((0,query_string.stringify)(queryParams));
};


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(2670);
// EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
var intersection_observer = __webpack_require__(6337);
;// CONCATENATED MODULE: ./src/utils/observer.ts



/**
 * Creates an intersection observer.
 * At minimum you need a callback function to fire on each element as it enters the viewport.
 * You can pass in optional object with threshold and margin.
 */ var getObserver = function(cb, options) {
    var OBSERVER_OPTIONS = (0,src_object_spread/* default */.Z)({
        rootMargin: "0px",
        threshold: 1.0
    }, options);
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                var element = entry.target;
                if (!entry.isIntersecting || !(0,_instanceof/* default */.Z)(element, HTMLElement)) {
                    return;
                }
                cb(element);
                observer.unobserve(element);
            }
        }, OBSERVER_OPTIONS);
    });
    return observer;
};

;// CONCATENATED MODULE: ./src/utils/images.ts

var setProps = function(image) {
    var deferSrc = image.getAttribute("defer-src");
    if (image.dataset.src) {
        image.setAttribute("src", image.dataset.src);
    }
    if (deferSrc) {
        image.setAttribute("src", deferSrc);
    }
    if (image.dataset.srcset) {
        image.setAttribute("srcSet", image.dataset.srcset);
    }
};
var setFade = function(image) {
    image.classList.add("loaded");
};
var initLazyImages = function() {
    var lazyLoadImages = document.querySelectorAll("img[loading='lazy']:not([src]), img[defer-src]:not([src]), img[data-src]:not([src])");
    var lazyNotDeferred = document.querySelectorAll("img[loading='lazy']");
    Array.from(lazyLoadImages).forEach(function(el) {
        var width = parseInt(el.getAttribute("width"), 10) || el.parentElement.offsetWidth;
        // our most common image aspect ratio is 2/1 so if all else fails, use it.
        var height = parseInt(el.getAttribute("height"), 10) || width / 2;
        // Inject an SVG to hold the image open at the correct size.
        // This prevents the page from thrashing as it scrolls.
        // eslint-disable-next-line max-len
        var placeHolder = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '.concat(width, " ").concat(height, '"%3E%3C/svg%3E');
        if (height && width) {
            // eslint-disable-next-line no-param-reassign
            el.src = placeHolder;
        }
    });
    var imageObserver = getObserver(setProps);
    var imageLoadObserver = getObserver(setFade);
    lazyLoadImages.forEach(function(image) {
        imageObserver.observe(image);
    });
    lazyNotDeferred.forEach(function(image) {
        imageLoadObserver.observe(image);
    });
};

;// CONCATENATED MODULE: ./src/components/ResponsiveImage.tsx









var pilboxConfig = {
    filter: "antialias",
    mode: "scale",
    pos: "top-left",
    opt: 1,
    prog: 1,
    q: "keep"
};
/**
 * Generates the CDN URL of an image given its path and the CDN URL.
 */ var getCDNUrl = function(path, media) {
    var url = !/^http/.test(path) ? "".concat(media, "/").concat(path) : path;
    return "".concat(url.replace("//media", "/media"));
};
/**
 * Provides a responsive image using srcSet, aspect ratios and pillbox.
 * @example
 * <ResponsiveImage
 *     alt="FluffyKins"
 *     className="jumbotron"
 *     url="//media/image.jpg"
 *     mobileWidth={320}
 *     tabletWidth={200}
 *     laptopWidth={162}
 *     desktopWidth={180}
 *     bigScreenWidth={206}
 *     mobileHeight={320}
 *     tabletHeight={200}
 *     laptopHeight={162}
 *     desktopHeight={180}
 *     bigScreenHeight={206}
 *     round{false}
 * />
 */ var ResponsiveImage = function(props) {
    var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, pilboxHost = _publicRuntimeConfig.pilboxHost, staticAssetHost = _publicRuntimeConfig.staticAssetHost;
    var url = props.url, mobileWidth = props.mobileWidth, tabletWidth = props.tabletWidth, laptopWidth = props.laptopWidth, desktopWidth = props.desktopWidth, bigScreenWidth = props.bigScreenWidth, mobileHeight = props.mobileHeight, tabletHeight = props.tabletHeight, laptopHeight = props.laptopHeight, desktopHeight = props.desktopHeight, bigScreenHeight = props.bigScreenHeight, className = props.className, altText = props.altText, credit = props.credit, creditLink = props.creditLink, caption = props.caption, mode = props.mode, loading = props.loading, extraProps = props.extraProps;
    if (!url) {
        return null;
    }
    // Images should always have an alt text.
    var alt = altText || caption || credit || "";
    // always fall back to the next smaller size.
    var mobileW = mobileWidth;
    var tabletW = tabletWidth || mobileW;
    var laptopW = laptopWidth || tabletW;
    var desktopW = desktopWidth || laptopW;
    var bigScreenW = bigScreenWidth || desktopW;
    // always fall back to the next smaller size.
    var mobileH = mobileHeight;
    var tabletH = tabletHeight || mobileH;
    var laptopH = laptopHeight || tabletH;
    var desktopH = desktopHeight || laptopH;
    var bigScreenH = bigScreenHeight || desktopH;
    var cdnUrl = getCDNUrl(url, staticAssetHost);
    // Generate each breakpoints Pilbox URL.
    var xs = genPilboxURL(pilboxHost, cdnUrl, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pilboxConfig), {
        mode: mode,
        w: mobileW,
        h: mobileH
    }));
    var sm = genPilboxURL(pilboxHost, cdnUrl, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pilboxConfig), {
        mode: mode,
        w: tabletW,
        h: tabletH
    }));
    var md = genPilboxURL(pilboxHost, cdnUrl, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pilboxConfig), {
        mode: mode,
        w: laptopW,
        h: laptopH
    }));
    var lg = genPilboxURL(pilboxHost, cdnUrl, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pilboxConfig), {
        mode: mode,
        w: desktopW,
        h: desktopH
    }));
    var xl = genPilboxURL(pilboxHost, cdnUrl, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pilboxConfig), {
        mode: mode,
        w: bigScreenW,
        h: bigScreenH
    }));
    // add some class names
    // eslint-disable-next-line react/destructuring-assignment
    var modifier = props.round ? "".concat((responsiveImageModule_module_default()).imageResponsive, " ").concat((responsiveImageModule_module_default()).imageRound) : (responsiveImageModule_module_default()).imageResponsive;
    var wrapperClass = [
        modifier,
        className
    ].join(" ");
    // Building up the srcSet as an object so we remove duplicate sizes/paths
    var srcSet = {};
    srcSet["".concat(mobileW, "w")] = xs;
    srcSet["".concat(tabletW, "w")] = srcSet["".concat(tabletW, "w")] || sm;
    srcSet["".concat(laptopW, "w")] = srcSet["".concat(laptopW, "w")] || md;
    srcSet["".concat(desktopW, "w")] = srcSet["".concat(desktopW, "w")] || lg;
    srcSet["".concat(bigScreenW, "w")] = srcSet["".concat(bigScreenW, "w")] || xl;
    // Building up the sizes as an object so we remove duplicate sizes/breakpoints
    var sizes = {};
    sizes["".concat(mobileW, "px")] = "(max-width: 567px)";
    sizes["".concat(tabletW, "px")] = sizes["".concat(tabletW, "px")] || "(min-width: 567px)";
    sizes["".concat(laptopW, "px")] = sizes["".concat(laptopW, "px")] || "(min-width: 1024px)";
    sizes["".concat(desktopW, "px")] = sizes["".concat(desktopW, "px")] || "(min-width: 1200px)";
    sizes["".concat(bigScreenW, "px")] = sizes["".concat(bigScreenW, "px")] || "(min-width: 1600px)";
    // Function for mapping over the SrcSet.
    var getSrcSet = function(key) {
        return "".concat(srcSet[key], " ").concat(key);
    };
    // loop over the srcset and join it all together `path size`
    var srcSetMap = Object.keys(srcSet).map(getSrcSet).join(",");
    // Function for mapping over the sizes.
    var getSize = function(val, _i, self) {
        return val === self[self.length - 1] ? val : "".concat(sizes[val], " ").concat(val);
    };
    // loop over the sizesMap and join it all together `breakpoint size`
    var sizesMap = Object.keys(sizes).map(getSize).join(",");
    var isEager = loading === "eager";
    (0,react.useEffect)(function() {
        initLazyImages();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,src_object_spread/* default */.Z)({
                alt: alt,
                className: isEager ? wrapperClass : "".concat(wrapperClass, " lazy"),
                "data-src": isEager ? undefined : xl,
                src: isEager ? xl : undefined,
                "data-srcset": isEager ? undefined : srcSetMap,
                srcSet: isEager ? srcSetMap : undefined,
                loading: loading || undefined,
                sizes: sizesMap,
                width: bigScreenW,
                height: bigScreenH
            }, extraProps)),
            !!caption || !!credit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption, {
                caption: caption,
                credit: credit,
                creditLink: creditLink
            }) : null
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/EmbedModule.tsx





var stripWhiteSpace = function(str) {
    return str.replace(/\n/g, "");
};
var stripEnclosingDivs = function(str) {
    var newstr = stripWhiteSpace(str);
    var ref;
    ref = (0,_sliced_to_array/* default */.Z)(newstr.match(/(?:<div>)(.*)(?=<\/div>)/m), 2), newstr = ref[1], ref;
    return newstr;
};
var getEmbedClassname = function(providerName) {
    var EmbedClassNameMap = {
        Facebook: "fb-embed-container",
        Twitter: "twitter-embed-container",
        YouTube: "ytplayer-embed-container",
        Instagram: "instagram-embed-container"
    };
    return Object.prototype.hasOwnProperty.call(EmbedClassNameMap, providerName) ? EmbedClassNameMap[providerName] : "other-embed-container";
};
var renderEmbed = function(embed, template) {
    var oskarView;
    var oskarProps;
    if (embed.type && embed.type === "video") {
        var mediaID;
        var mediaProviderKey;
        if (embed.providerName === "YouTube") {
            mediaID = embed.url;
            mediaProviderKey = embed.url.split("=")[1];
        }
        var eventProps = {
            sp_impression_component: "insert",
            sp_impression_insert_type: "media",
            sp_impression_position: template === "article" ? "in_article" : null,
            sp_media_type: "video",
            sp_media_id: mediaID,
            sp_media_name: embed.title || null,
            sp_media_provider_key: mediaProviderKey || null,
            sp_media_provider_name: embed.providerName || null
        };
        var trackingProps = {
            viewEvent: "videoViewed",
            eventProps: eventProps
        };
        var dataProps = (0,tracking/* getTrackingPropsAsDataAttrs */.hf)(trackingProps);
        var ref;
        ref = dataProps, oskarView = ref.oskarView, oskarProps = ref.oskarProps, ref;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: getEmbedClassname(embed.providerName),
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: stripEnclosingDivs(embed.code)
        },
        "data-video-view": oskarView,
        "data-oskar-props": oskarProps
    });
};
var EmbedModule = function(param) {
    var heading = param.heading, embed = param.embed, richText = param.richText, template = param.template;
    var embedContent = embed.embed;
    if (!embedContent) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "article-body__content-module__embed",
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: heading
            }),
            renderEmbed(embedContent, template),
            richText && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
                className: "article-body__content-module__embed__rich-text",
                type: "richTextBlock",
                richText: richText
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/LeadMediaModule.tsx










var getPinUrl = function(href, media, description) {
    var page = encodeURIComponent(href);
    var image = encodeURIComponent(media);
    var alt = encodeURIComponent(description);
    return "https://www.pinterest.com/pin/create/button/?url=".concat(page, "&media=").concat(image, "&description=").concat(alt);
};
var Pinterest = function(alt, url, href) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (leadMedia_module_default()).imagePin,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: getPinUrl(href, url, alt),
                rel: "nofollow noreferrer",
                target: "_blank",
                className: "".concat((leadMedia_module_default()).button, " ").concat((leadMedia_module_default()).socialIcon, " ").concat((leadMedia_module_default()).pinterest),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SVGIconPinterestBox, {})
            })
        })
    });
};
var RenderLeadImage = function(props) {
    var _height = props.height, height = _height === void 0 ? 100 : _height, _width = props.width, width = _width === void 0 ? 100 : _width, url = props.url, altText = props.altText, credit = props.credit, creditLink = props.creditLink, caption = props.caption;
    var aspect = height / width;
    var mobileWidth = constants/* LEAD_MEDIA_SMALL_WIDTH */.pB;
    var tabletWidth = constants/* LEAD_MEDIA_LARGE_WIDTH */.Zh;
    var mobileHeight = Math.ceil(mobileWidth * aspect);
    var tabletHeight = Math.ceil(tabletWidth * aspect);
    var extraProps = {
        fetchpriority: "high"
    };
    var leadImageProps = {
        altText: altText,
        caption: caption,
        className: (leadMedia_module_default()).imageResponsive,
        // The following linter issue is a bug in eslint
        // eslint-disable-next-line no-undef
        loading: "eager",
        credit: credit,
        creditLink: creditLink,
        mobileHeight: mobileHeight,
        mobileWidth: mobileWidth,
        tabletWidth: tabletWidth,
        tabletHeight: tabletHeight,
        url: url,
        extraProps: extraProps
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage, (0,src_object_spread/* default */.Z)({}, leadImageProps));
};
var RenderEmbedVideo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbedModule, {
        type: "embedBlock",
        embed: props,
        template: "leadMedia"
    });
};
var RenderJWVideo = function(props) {
    var jwVideo = props.jwVideo;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JWVideoModule, {
        type: "jwVideoBlock",
        jwVideo: jwVideo,
        autostart: true,
        position: "post_individual_header"
    });
};
var LeadMediaModule = function(props) {
    var pageMetaData = (0,AppContext/* useAppState */.mr)().pageMetaData;
    var href = pageMetaData.href;
    var altText = props.altText, showPinterest = props.showPinterest, type = props.type, url = props.url;
    // The following linter issue is a bug in eslint
    // eslint-disable-next-line no-undef
    var renderMethod = {
        image: RenderLeadImage,
        embedVideo: RenderEmbedVideo,
        jwVideo: RenderJWVideo
    };
    var getLead = renderMethod[type];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: (leadMedia_module_default()).leadMedia,
        children: [
            getLead && getLead(props),
            showPinterest && Pinterest(altText, url, href)
        ]
    });
};

// EXTERNAL MODULE: ./src/components/articleSocial.module.scss
var articleSocial_module = __webpack_require__(9817);
var articleSocial_module_default = /*#__PURE__*/__webpack_require__.n(articleSocial_module);
;// CONCATENATED MODULE: ./src/components/ArticleSocial.tsx


/* eslint-disable max-len */ 


var ref = (0,config["default"])(), museHost = ref.publicRuntimeConfig.museHost;
var getFaceBookUrl = function(articleUri) {
    var base = "https://www.facebook.com/sharer/sharer.php?u=";
    var article = encodeURIComponent("".concat(museHost, "/").concat(articleUri));
    return "".concat(base).concat(article);
};
var getTwitterUrl = function(articleUri, title, twitterHandle) {
    var base = "https://twitter.com/share?url=";
    var heading = "&text=".concat(encodeURIComponent(title));
    var signature = twitterHandle === "themuse" ? "%20%40TheMuse" : "%20%40TheMuse%20%40".concat(twitterHandle);
    var article = encodeURIComponent("".concat(museHost, "/").concat(articleUri));
    return "".concat(base).concat(article).concat(heading).concat(signature);
};
var getLinkedInUrl = function(articleUri, title) {
    var base = "http://www.linkedin.com/shareArticle?mini=true&url=";
    var heading = "&source=The%20Muse&title=";
    return "".concat(base).concat(museHost, "/").concat(articleUri).concat(heading).concat(title.split(" ").join("+"));
};
var getEmailUrl = function(articleUri, title) {
    var subject = "mailto:?Subject=".concat(title);
    var body = "&body=Just read this awesome article I thought I would share with you! Check it out here: ";
    var url = "".concat(subject).concat(body, "$").concat(museHost, "/").concat(articleUri);
    return url;
};
var facebookIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-hidden": "false",
        role: "img",
        "aria-labelledby": "facebook-social",
        "aria-label": "Share on Facebook",
        height: "1em",
        width: "1em",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: "facebook-social",
                children: "Facebook"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFF",
                d: "M9 8H6v4h3v12h5V12h3.642L18 8h-4V6.333C14 5.378 14.192 5 15.115 5H18V0h-3.808C10.596 0 9 1.583 9 4.615V8z"
            })
        ]
    });
};
var linkedinIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-hidden": "false",
        role: "img",
        "aria-labelledby": "linkedin-social",
        "aria-label": "Share on LinkedIn",
        height: "1em",
        width: "1em",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: "linkedin-social",
                children: "LinkedIn"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFF",
                d: "M4.98 3.5C4.98 4.881 3.87 6 2.5 6S.02 4.881.02 3.5C.02 2.12 1.13 1 2.5 1s2.48 1.12 2.48 2.5zM5 8H0v16h5V8zm7.982 0H8.014v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0V24H24V13.869c0-7.88-8.922-7.593-11.018-3.714V8z"
            })
        ]
    });
};
var twitterIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-hidden": "false",
        role: "img",
        "aria-labelledby": "twitter-social",
        "aria-label": "Share on Twitter",
        height: "1em",
        width: "1em",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: "twitter-social",
                children: "Twitter"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFF",
                d: "M24 4.557a9.83 9.83 0 01-2.828.775 4.932 4.932 0 002.165-2.724 9.864 9.864 0 01-3.127 1.195 4.916 4.916 0 00-3.594-1.555c-3.179 0-5.515 2.966-4.797 6.045A13.978 13.978 0 011.671 3.149a4.93 4.93 0 001.523 6.574 4.903 4.903 0 01-2.229-.616c-.054 2.281 1.581 4.415 3.949 4.89a4.935 4.935 0 01-2.224.084 4.928 4.928 0 004.6 3.419A9.9 9.9 0 010 19.54a13.94 13.94 0 007.548 2.212c9.142 0 14.307-7.721 13.995-14.646A10.025 10.025 0 0024 4.557z"
            })
        ]
    });
};
var emailIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-hidden": "false",
        role: "img",
        "aria-labelledby": "email-social",
        "aria-label": "Share via Email",
        height: "1em",
        width: "1em",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: "email-social",
                children: "Email"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#FFF",
                d: "M29.728 26.848v-13.696q-0.576 0.64-1.248 1.152-4.768 3.68-7.616 6.048-0.896 0.768-1.472 1.184t-1.536 0.896-1.824 0.416h-0.064q-0.832 0-1.824-0.416t-1.536-0.896-1.472-1.184q-2.816-2.368-7.616-6.048-0.672-0.512-1.248-1.152v13.696q0 0.224 0.192 0.416t0.384 0.16h26.304q0.224 0 0.384-0.16t0.192-0.416zM29.728 8.096v-0.448t-0.032-0.224-0.032-0.224-0.096-0.16-0.16-0.128-0.256-0.064h-26.304q-0.224 0-0.384 0.192t-0.192 0.384q0 3.008 2.656 5.088 3.424 2.688 7.136 5.632 0.128 0.096 0.64 0.544t0.8 0.672 0.8 0.544 0.896 0.512 0.768 0.16h0.064q0.352 0 0.768-0.16t0.896-0.512 0.8-0.544 0.8-0.672 0.64-0.544q3.712-2.944 7.168-5.632 0.96-0.768 1.792-2.080t0.832-2.336zM32 7.424v19.424q0 1.184-0.832 2.016t-2.016 0.864h-26.304q-1.152 0-2.016-0.864t-0.832-2.016v-19.424q0-1.184 0.832-2.016t2.016-0.832h26.304q1.184 0 2.016 0.832t0.832 2.016z"
            })
        ]
    });
};
/**
 * Generates an anchor wrapped around the social icon.
 */ var getIcon = function(props) {
    var url = props.url, type = props.type;
    var socialIcons = {
        facebook: facebookIcon,
        twitter: twitterIcon,
        linkedin: linkedinIcon,
        email: emailIcon
    };
    var Icon = socialIcons[type];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: "".concat((articleSocial_module_default()).icon, " ").concat((articleSocial_module_default())[type]),
        "aria-label": type,
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
    });
};
/**
 * Generates the Social Sidebar Module.  This includes the Author Byline and the 4 social icons.
 */ var ArticleSocial = function(props) {
    var articleUri = props.articleUri, title = props.title, twitterHandle = props.twitterHandle, writerName = props.writerName, writerSlug = props.writerSlug, dateUpdated = props.dateUpdated;
    var handle = twitterHandle ? twitterHandle.replace("@", "") : "themuse";
    var emailUrl = getEmailUrl(articleUri, title);
    var faceBookUrl = getFaceBookUrl(articleUri);
    var twitterUrl = getTwitterUrl(articleUri, title, handle);
    var linkedInUrl = getLinkedInUrl(articleUri, title);
    var writerUri = "/author/".concat(writerSlug);
    var formattedDate = new Date(dateUpdated).toLocaleDateString("en-US");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        id: "social-marker",
        className: (articleSocial_module_default()).social,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (articleSocial_module_default()).articleMetadata,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (articleSocial_module_default()).dataGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (articleSocial_module_default()).metadataField,
                                children: "by"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (articleSocial_module_default()).metadataData,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: writerUri,
                                    children: writerName
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (articleSocial_module_default()).dataGroup,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (articleSocial_module_default()).metadataField,
                                children: "Updated"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (articleSocial_module_default()).metadataData,
                                children: formattedDate
                            })
                        ]
                    })
                ]
            }),
            getIcon((0,src_object_spread/* default */.Z)({}, {
                url: faceBookUrl,
                type: "facebook"
            })),
            getIcon((0,src_object_spread/* default */.Z)({}, {
                url: twitterUrl,
                type: "twitter"
            })),
            getIcon((0,src_object_spread/* default */.Z)({}, {
                url: linkedInUrl,
                type: "linkedin"
            })),
            getIcon((0,src_object_spread/* default */.Z)({}, {
                url: emailUrl,
                type: "email"
            }))
        ]
    });
};

// EXTERNAL MODULE: ./src/components/articleContainer.module.scss
var articleContainer_module = __webpack_require__(4847);
var articleContainer_module_default = /*#__PURE__*/__webpack_require__.n(articleContainer_module);
;// CONCATENATED MODULE: ./src/components/HtmlModule.tsx



var HtmlModule = function(props) {
    var html = props.html;
    // eslint-disable-next-line react/no-danger
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (articleContainer_module_default()).contentModule,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};

// EXTERNAL MODULE: ./src/components/blockQuote.module.scss
var blockQuote_module = __webpack_require__(8110);
var blockQuote_module_default = /*#__PURE__*/__webpack_require__.n(blockQuote_module);
;// CONCATENATED MODULE: ./src/components/BlockQuoteModule.tsx




var BlockQuoteModule = function(param) {
    var blockquote = param.blockquote, attribution = param.attribution;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (blockQuote_module_default()).pullQuote,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((blockQuote_module_default()).quoteMark, "  ").concat((blockQuote_module_default()).open),
                children: "\u201C"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
                    type: "richTextBlock",
                    richText: blockquote
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((blockQuote_module_default()).quoteMark, "  ").concat((blockQuote_module_default()).close),
                children: "\u201D"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                children: [
                    "\u2014\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
                        className: (blockQuote_module_default()).richText,
                        type: "richTextBlock",
                        richText: attribution
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/divider.module.scss
var divider_module = __webpack_require__(5886);
var divider_module_default = /*#__PURE__*/__webpack_require__.n(divider_module);
;// CONCATENATED MODULE: ./src/components/DividerModule.tsx




var DividerModule = function(param) {
    var heading = param.heading, richText = param.richText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (divider_module_default()).divider,
        children: [
            heading && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: heading
            }),
            richText && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
                richText: richText,
                type: "richTextBlock"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/TocModule.tsx


var TOCList = function(props) {
    var children = props.children, style = props.style;
    return style === "numeric" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        children: children
    });
};
/**
 * Return only the heading and the ID
 */ var createEntry = function(module) {
    var heading = module.heading, id = module.id, inToc = module.inToc, type = module.type;
    return inToc ? {
        heading: heading,
        id: id,
        inToc: inToc,
        type: type
    } : null;
};
/**
 * Checks to see if we have ny items are marked as being part of the TOC.
 */ var hasTocItems = function(modules) {
    return !!modules && !!modules.filter(function(module) {
        return module && module.inToc && module.heading;
    }).length;
};
/**
 * Checks to see if we have a TOC generator.
 */ var hasTocGenerator = function(modules) {
    return !!modules.filter(function(module) {
        return module && module.type === "tocGenerator";
    }).length;
};
/**
 * Checks for tocItems and generators.
 */ var hasToc = function(modules) {
    return hasTocItems(modules) && hasTocGenerator(modules);
};
/**
 * Get all headings and IDs that are part of the TOC or an empty array.
 */ var getTOCEntries = function(modules) {
    return !!modules && hasToc(modules) ? modules.filter(function(module) {
        return module && module.inToc && module.heading;
    }).map(createEntry) : [];
};
/**
 * Generate the list item either a paragraph for dividers or an LI.
 */ var ListItem = function(props) {
    var cleanHeading = props.cleanHeading, id = props.id, index = props.index, type = props.type;
    return type === "divider" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "#".concat(id),
            children: cleanHeading
        })
    }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "#".concat(id),
            children: cleanHeading
        })
    }, index);
};
/**
 * Generates a Table of contents. With jump links to the content.
 */ var TocModule = function(props) {
    var style = props.style, entities = props.entities;
    if (!entities) {
        return null;
    }
    var listItems = entities.map(function(item, index) {
        var heading = item.heading, id = item.id, inToc = item.inToc, type = item.type;
        // We strip out the markup for clean text in the bullet. We do not want nested anchors.
        var cleanHeading = inToc && heading && heading.replace(/<[^>]*>?/gm, "");
        return !!cleanHeading && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
            cleanHeading: cleanHeading,
            id: id,
            index: index,
            type: type
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TOCList, {
        style: style,
        children: listItems
    });
};

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
// EXTERNAL MODULE: ./src/components/company.module.scss
var company_module = __webpack_require__(8900);
var company_module_default = /*#__PURE__*/__webpack_require__.n(company_module);
;// CONCATENATED MODULE: ./src/components/CompanyModule.tsx





/* eslint-disable @typescript-eslint/no-unused-vars */ 








var Description = function(param) {
    var isArticle = param.isArticle, description = param.description, replaceDescription = param.replaceDescription, richText = param.richText;
    var Extended = (0,react.useCallback)(function() {
        return richText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
            type: "richTextBlock",
            className: "extended",
            richText: richText
        }) : null;
    }, [
        richText
    ]);
    var Static = (0,react.useCallback)(function() {
        return description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
            type: "richTextBlock",
            className: "legacy",
            richText: description
        }) : null;
    }, [
        description
    ]);
    var Both = (0,react.useCallback)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Static, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Extended, {})
            ]
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isArticle ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (company_module_default()).description,
            children: replaceDescription ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Extended, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Both, {})
        })
    });
};
/**
 * Creates a company module within the page.
 * Passing an order number will render a listicle style with both a heading and description.
 * @example
 * <CompanyModule {...MOCK_COMPANY} />
 * <CompanyModule isArticle={true}{...MOCK_COMPANY} />
 */ var CompanyModule = function(props) {
    var isArticle = props.isArticle, replaceDescription = props.replaceDescription, richText = props.richText, orderNum = props.orderNum, company = props.company;
    var shortName = company.shortName, primaryImage = company.primaryImage, secondaryImage = company.secondaryImage, tertiaryImage = company.tertiaryImage, description = company.description, title = company.title, slug = company.slug, legacyId = company.legacyId, id = company.id;
    var aspect = 0.73896353167;
    var alt = {
        profile: "".concat(title, " company profile"),
        culture: "".concat(title, "  culture"),
        working: "Working at ".concat(title)
    };
    var impressionTrackingProps = {
        content_type: "module",
        company_name: title,
        company_short_name: slug,
        company_id: legacyId,
        company_craft_id: id,
        placement_position: orderNum,
        sp_content_is_tile: true,
        sp_tile_entity_id: getId(legacyId).toString(),
        sp_tile_order: orderNum,
        sp_tile_type: "round_up",
        sp_tile_company_id: legacyId.toString(),
        sp_impression_component: "tile",
        sp_impression_position: "in_article",
        sp_impression_tile_type: "round_up",
        sp_page_section: "advice",
        sp_page_type: "content"
    };
    var serializedImpressionTrackingProps = JSON.stringify(impressionTrackingProps);
    var clickTrackingProps = {
        sp_click_component: "button",
        sp_click_component_tile_type: "round_up",
        sp_click_insert_type: null,
        sp_click_position: "main",
        sp_click_search_id: null,
        sp_page_type: "content",
        sp_page_section: "advice",
        sp_page_company_id: legacyId.toString(),
        sp_page_tab: null,
        sp_is_external_page: false,
        sp_page_entity_id: id,
        sp_tile_entity_id: getId(legacyId).toString(),
        sp_tile_order: orderNum,
        sp_tile_type: "round_up",
        sp_tile_company_id: legacyId.toString()
    };
    var profileTrackingProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clickTrackingProps), {
        sp_click_button_text: "view profile",
        sp_click_button_type: "profile",
        sp_click_component: "button",
        sp_click_target_page_section: "profile"
    });
    var ref = (0,react.useState)(), jobsCount = ref[0], setJobsCount = ref[1];
    var getSearchTrackingProps = (0,react.useCallback)(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clickTrackingProps), {
            sp_click_button_text: jobsCount ? "Explore ".concat(jobsCount, " Open Jobs") : "Explore Jobs",
            sp_click_button_type: "job_search",
            sp_click_component: "button",
            sp_click_target_page_section: "search"
        });
    }, [
        jobsCount
    ]);
    var imageTrackingProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clickTrackingProps), {
        sp_click_component: "tile",
        sp_tile_entity_id: getId(legacyId).toString(),
        sp_tile_order: orderNum,
        sp_tile_company_id: legacyId.toString(),
        sp_click_target_page_section: "profile"
    });
    var imageTrackingData = {
        "data-tracking-event-type": "click",
        "data-tracking-props": JSON.stringify(imageTrackingProps)
    };
    var mobilePrimary = 325;
    var tabletPrimary = 447;
    var mobileSecondary = 217;
    var sizesPrimary = {
        mobileWidth: mobilePrimary,
        mobileHeight: Math.ceil(mobilePrimary * aspect),
        tabletWidth: tabletPrimary,
        tabletHeight: Math.ceil(tabletPrimary * aspect)
    };
    var sizesSecondary = {
        mobileWidth: mobileSecondary,
        mobileHeight: Math.ceil(mobileSecondary * aspect)
    };
    var profileUrl = "/profiles/".concat(shortName);
    var jobsUrl = "/hiring/company/".concat(shortName);
    var getJobCount = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, ref1, apiBase, url, jobCount, ref2;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    ref1 = (0,config["default"])(), apiBase = ref1.publicRuntimeConfig.apiBase;
                    url = "".concat(apiBase, "/job-search?company_short_name=").concat(shortName);
                    _ctx.next = 5;
                    return axios_default().get(url, {
                        method: "GET",
                        timeout: 5000,
                        headers: {
                            "content-type": "application/json;charset=UTF-8"
                        }
                    });
                case 5:
                    jobCount = _ctx.sent;
                    ;
                    setJobsCount((ref2 = jobCount === null || jobCount === void 0 ? void 0 : (ref = jobCount.data) === null || ref === void 0 ? void 0 : ref.count) !== null && ref2 !== void 0 ? ref2 : 0);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        shortName
    ]);
    var intersectionProps = {
        triggerOnce: true,
        rootMargin: "0px"
    };
    var ref1 = (0,react_intersection_observer_modern/* useInView */.YD)(intersectionProps), ref2 = ref1.ref, inView = ref1.inView;
    (0,react.useEffect)(function() {
        if (inView) {
            getJobCount();
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: ref2,
        "data-oskar-click": "adviceCompanyModuleClicked",
        "data-oskar-view": "adviceCompanyModuleViewed",
        "data-oskar-props": serializedImpressionTrackingProps,
        "data-tracking-event-type": "impression",
        "data-tracking-props": serializedImpressionTrackingProps,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                    className: (company_module_default()).officeGrid,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (company_module_default()).primary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profileUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                                    loading: "lazy",
                                    altText: alt.profile,
                                    url: primaryImage
                                }, sizesPrimary), {
                                    extraProps: imageTrackingData
                                }))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (company_module_default()).secondary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profileUrl,
                                "data-tracking-event-type": "click",
                                "data-tracking-props": JSON.stringify(profileTrackingProps),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage, (0,src_object_spread/* default */.Z)({
                                    extraProps: imageTrackingData,
                                    loading: "lazy",
                                    altText: alt.culture,
                                    url: secondaryImage
                                }, sizesSecondary))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (company_module_default()).tertiary,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profileUrl,
                                "data-tracking-event-type": "click",
                                "data-tracking-props": JSON.stringify(profileTrackingProps),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage, (0,src_object_spread/* default */.Z)({
                                    extraProps: imageTrackingData,
                                    loading: "lazy",
                                    altText: alt.working,
                                    url: tertiaryImage
                                }, sizesSecondary))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (company_module_default()).ctaButtons,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SquareButton */.LE, {
                            className: (company_module_default()).squareButton,
                            color: "light-blue",
                            href: profileUrl,
                            target: "_blank",
                            "data-tracking-event-type": "click",
                            "data-tracking-props": JSON.stringify(profileTrackingProps),
                            children: "View Profile"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SquareButton */.LE, {
                            className: (company_module_default()).squareButton,
                            color: "mint",
                            href: jobsUrl,
                            target: "_blank",
                            "data-tracking-event-type": "click",
                            "data-tracking-props": JSON.stringify(getSearchTrackingProps()),
                            children: jobsCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "Explore",
                                    " ",
                                    jobsCount,
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "hidden visible--sm",
                                        children: "Open"
                                    }),
                                    " ",
                                    "Jobs"
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "Explore Jobs"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                    isArticle: isArticle,
                    replaceDescription: replaceDescription,
                    description: description,
                    richText: richText
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/sponsoredRecircWidget.module.scss
var sponsoredRecircWidget_module = __webpack_require__(5649);
var sponsoredRecircWidget_module_default = /*#__PURE__*/__webpack_require__.n(sponsoredRecircWidget_module);
;// CONCATENATED MODULE: ./src/components/SponsoredRecircWidget.tsx






var SponsoredRecircWidget = function(props) {
    var companyLogoUrl = props.companyLogoUrl, companyName = props.companyName, companyProfileUrl = props.companyProfileUrl, companyImageUrl = props.companyImageUrl;
    var clickTrackingProps = {
        "data-tracking-event-type": "click",
        "data-tracking-props": JSON.stringify({
            sp_click_component: "button",
            sp_click_button_type: "job_search",
            sp_click_insert_type: "sponsor_company_jobs",
            sp_click_button_text: "learn more",
            sp_click_position: "right_rail",
            sp_click_target_page_position: "profile"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (sponsoredRecircWidget_module_default()).sponsoredRecircWidget,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (sponsoredRecircWidget_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (sponsoredRecircWidget_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* CompanyLogoOutlined */.uC, {
                            className: (sponsoredRecircWidget_module_default()).logoPill,
                            altText: "".concat(companyName, " Logo"),
                            logoUrl: companyLogoUrl
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: "".concat(companyName, " Profile"),
                            loading: "lazy",
                            className: (sponsoredRecircWidget_module_default()).companyImage,
                            width: 300,
                            height: 200,
                            src: companyImageUrl
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (sponsoredRecircWidget_module_default()).mainContent,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                        className: (sponsoredRecircWidget_module_default()).title,
                        children: [
                            "Explore Jobs At",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (sponsoredRecircWidget_module_default()).companyName,
                                children: companyName
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (sponsoredRecircWidget_module_default()).footer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SquareButton */.LE, {
                        className: (sponsoredRecircWidget_module_default()).companyProfileCta,
                        color: "secondary-100",
                        href: companyProfileUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clickTrackingProps), {
                            children: "Learn More"
                        }))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (sponsoredRecircWidget_module_default()).museLogo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* MuseLogo */.wJ, {})
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/utils/location.ts
function translateDMAString(dma) {
    var city = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    // Some DMA strings need to be translated from their original string to a simpler string for display purposes.
    // Some DMA strings also contain multiple locations and we want to sometimes return an individual city instead of
    // the DMA string. Carmen separates city and state so we map directly from a city within a DMA to a city/state value
    var dmaCityTranslations = {
        "Albuquerque-Santa Fe, NM": {
            default: "Albuquerque, NM",
            "Sante Fe": "Sante Fe, NM"
        },
        "Boston, MA-Manchester, NH": {
            default: "Boston, MA",
            Manchester: "Manchester, NH"
        },
        "Cleveland-Akron (Canton), OH": {
            default: "Cleveland, OH",
            Akron: "Akron, OH"
        },
        "Dallas-Ft. Worth, TX": {
            default: "Dallas, TX"
        },
        "Greensboro-High Point-Winston Salem, NC": {
            default: "Greensboro, NC",
            "High Point": "High Point, NC",
            "Winston Salem": "Winston Salem, NC"
        },
        "Harrisburg-Lancaster-Lebanon-York, PA": {
            default: "Harrisburg, PA",
            Lancaster: "Lancaster, PA"
        },
        "Hartford & New Haven, CT": {
            default: "Hartford, CT",
            "New Haven": "New Haven, CT"
        },
        "Miami-Ft. Lauderdale, FL": {
            default: "Miami, FL",
            "Fort Lauderdale": "Fort Lauderdale, FL"
        },
        "Minneapolis-St. Paul, MN": {
            default: "Minneapolis, MN",
            "Saint Paul": "Saint Paul, MN"
        },
        "New York, NY": {
            default: "New York, NY",
            Brooklyn: "Brooklyn, NY",
            "Jersey City": "Jersey City, NJ"
        },
        "Norfolk-Portsmouth-Newport News,VA": {
            default: "Norfolk, VA",
            "Newport News": "Newport News, VA"
        },
        "Orlando-Daytona Beach-Melbourne, FL": {
            default: "Orlando, FL",
            "Daytona Beach": "Daytona Beach, FL"
        },
        "Raleigh-Durham (Fayetteville), NC": {
            default: "Raleigh, NC",
            Durham: "Durham, NC"
        },
        "Richmond-Petersburg, VA": {
            default: "Richmond, VA"
        },
        "Sacramento-Stockton-Modesto, CA": {
            default: "Sacramento, CA"
        },
        "San Francisco-Oakland-San Jose, CA": {
            default: "San Francisco, CA",
            Oakland: "Oakland, CA",
            "San Jose": "San Jose, CA"
        },
        "Seattle-Tacoma, WA": {
            default: "Seattle, WA",
            Tacoma: "Tacoma, WA"
        },
        "Tampa-St Petersburg (Sarasota), FL": {
            default: "Tampa, FL",
            "St. Petersburg": "St. Petersburg, FL"
        },
        "Washington, DC (Hagerstown, MD)": {
            default: "Washington, DC",
            Arlington: "Arlington, VA"
        }
    };
    if (dmaCityTranslations[dma]) {
        return dmaCityTranslations[dma][city] ? dmaCityTranslations[dma][city] : dmaCityTranslations[dma].default;
    }
    return dma;
}
var getAllowedLocationFromDMA = function(dma) {
    var allowedDMAs = [
        "New York, NY",
        "San Francisco, CA",
        "Chicago, IL",
        "Boston, MA",
        "Washington, DC",
        "Austin, TX",
        "Denver, CO",
        "Seattle, WA",
        "Los Angeles, CA"
    ];
    return allowedDMAs.includes(dma) ? dma : "";
};

// EXTERNAL MODULE: ./src/components/jobsSidebar.module.scss
var jobsSidebar_module = __webpack_require__(8747);
var jobsSidebar_module_default = /*#__PURE__*/__webpack_require__.n(jobsSidebar_module);
;// CONCATENATED MODULE: ./src/components/SvgIconLocation2Shape.tsx




/* eslint-disable max-len */ 
var SvgIconLocation2Shape = function(_param) /*#__PURE__*/ {
    var title = _param.title, titleId = _param.titleId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleId"
    ]);
    return (0,jsx_runtime.jsxs)("svg", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 24",
        "aria-labelledby": titleId
    }, props), {
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10 .934c5.134 0 9.295 4.201 9.295 9.383 0 7.714-6.546 9.902-9.295 13.634C7.322 20.204.705 18.42.705 10.317.705 5.135 4.866.934 10 .934zm0 4.497c-2.727 0-4.938 2.187-4.938 4.886 0 2.698 2.211 4.886 4.938 4.886s4.938-2.188 4.938-4.886c0-2.699-2.211-4.886-4.938-4.886z",
                fillRule: "evenodd"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/JobsSidebar.tsx











var JobsHeader = function(param) {
    var location = param.location;
    var suffix = location ? "in ".concat(location) : "on The Muse";
    var headerText = "Hot Jobs ".concat(suffix);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: (jobsSidebar_module_default()).header,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (jobsSidebar_module_default()).text,
            children: headerText
        })
    });
};
var ButtonLink = function(param) {
    var className = param.className, href = param.href, color = param.color, clickEvent = param.clickEvent, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((jobsSidebar_module_default()).buttonLink, " ").concat(className || ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SquareButton */.LE, {
            target: "_blank",
            href: href,
            color: color,
            "data-oskar-click": clickEvent,
            children: children
        })
    });
};
var ExploreLink = function(_param) {
    var searchUrl = _param.searchUrl, location = _param.location, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "searchUrl",
        "location"
    ]);
    var url = searchUrl;
    var buttonClickTrackingProps = {
        "data-tracking-event-type": "click",
        "data-tracking-props": JSON.stringify({
            sp_click_component: "button",
            sp_click_button_type: "job_search",
            sp_click_insert_type: "hot_jobs",
            sp_click_button_text: "explore all jobs",
            sp_click_position: "right_rail",
            sp_click_target_page_position: "search"
        })
    };
    if (location) {
        url += "/location/".concat(slugify(location), "/radius/100mi");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        href: url,
        className: (jobsSidebar_module_default()).explore,
        color: "secondary-100"
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            className: (jobsSidebar_module_default()).fullText
        }, buttonClickTrackingProps), {
            children: "Explore All Jobs"
        }))
    }));
};
var IconContainer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (jobsSidebar_module_default()).iconContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (jobsSidebar_module_default()).icon,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (jobsSidebar_module_default()).pin,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIconLocation2Shape, {})
            })
        })
    });
};
var HotJobs = function(_param) {
    var searchUrl = _param.searchUrl, keywords = _param.keywords, location = _param.location, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "searchUrl",
        "keywords",
        "location"
    ]);
    var defaultKeywords = [
        "sales",
        "marketing",
        "product",
        "software engineering", 
    ];
    var searchPath = searchUrl;
    var linkKeywords = keywords && keywords.length ? keywords : defaultKeywords;
    var hotJobsLinks = linkKeywords.map(function(keyword) {
        var buttonUrl = "".concat(searchPath, "/keyword/").concat(keyword);
        var buttonClickTrackingProps = {
            "data-tracking-event-type": "click",
            "data-tracking-props": JSON.stringify({
                sp_click_component: "button",
                sp_click_button_type: "job_search",
                sp_click_insert_type: "hot_jobs",
                sp_click_button_text: "".concat(keyword, " jobs"),
                sp_click_position: "right_rail",
                sp_click_target_page_position: "search"
            })
        };
        if (location) {
            buttonUrl += "/location/".concat(slugify(location), "/radius/100mi");
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            color: "accent3"
        }, rest), {
            href: buttonUrl,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                className: "full-text"
            }, buttonClickTrackingProps), {
                children: [
                    keyword,
                    " ",
                    "Jobs"
                ]
            }))
        }), "".concat(keyword));
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (jobsSidebar_module_default()).hotJobs,
        children: hotJobsLinks
    });
};
/**
 * Renders the Hot Jobs Sidebar
 */ var JobsSidebar = function(param) {
    var searchUrl = param.searchUrl, keywords = param.keywords;
    var user = (0,AppContext/* useAppState */.mr)().user;
    var _location = user.location, _dma = _location.dma, dma = _dma === void 0 ? "" : _dma;
    var searchPath = searchUrl || "/hiring";
    var trackingLocation = getAllowedLocationFromDMA(translateDMAString(dma));
    var moduleImpressionTrackingProps = {
        "data-tracking-event-type": "impression",
        "data-tracking-props": JSON.stringify({
            sp_impression_component: "insert",
            sp_impression_insert_type: "hot_jobs",
            sp_impression_position: "right_rail"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (jobsSidebar_module_default()).jobsSidebarWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            className: (jobsSidebar_module_default()).jobsSidebar
        }, moduleImpressionTrackingProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (jobsSidebar_module_default()).container,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(JobsHeader, {
                            location: trackingLocation
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HotJobs, {
                            location: trackingLocation,
                            keywords: keywords,
                            searchUrl: searchPath
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExploreLink, {
                            location: trackingLocation,
                            searchUrl: searchPath
                        }),
                        trackingLocation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (jobsSidebar_module_default()).searchLocation,
                            children: [
                                "Not your city?",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: searchPath,
                                    children: "Search By Location"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                            location: trackingLocation
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (jobsSidebar_module_default()).logo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* MuseLogo */.wJ, {})
                })
            ]
        }))
    });
};

// EXTERNAL MODULE: ./src/components/sponsorModule.module.scss
var sponsorModule_module = __webpack_require__(1719);
var sponsorModule_module_default = /*#__PURE__*/__webpack_require__.n(sponsorModule_module);
;// CONCATENATED MODULE: ./src/components/SponsorModule.tsx



/* eslint-disable @typescript-eslint/no-unused-vars */ 








/**
 * Return an object with all the possible sponsor placements and if they are valid.
 */ var getSponsorPlacement = function(props) {
    var launchReg = new RegExp("launch", "i");
    var roundupReg = new RegExp("roundup", "i");
    var sponsoredArticleReg = new RegExp("sponsored-article", "i");
    var existingReg = new RegExp("existing-article-sponsorship", "i");
    var tierReg = new RegExp("tier", "i");
    var isActive = props.active;
    var isEmpty = props.product === "";
    var isExisting = existingReg.test(props.product);
    var isLaunch = launchReg.test(props.product);
    var isRoundup = roundupReg.test(props.product);
    var isSponsored = props.hasSponsorShip;
    var isSponsoredArticle = sponsoredArticleReg.test(props.product);
    var isTier = tierReg.test(props.product);
    var placement = {
        footer: [
            isSponsored,
            isActive,
            !isRoundup,
            !isEmpty
        ].every(Boolean),
        sidebar: [
            isSponsored,
            isActive,
            !isRoundup,
            !isEmpty
        ].every(Boolean),
        inline: [
            isSponsored,
            isActive,
            !isLaunch,
            !isEmpty
        ].every(Boolean),
        bio: [
            [
                isSponsored,
                isActive,
                !isTier,
                !isLaunch,
                !isExisting
            ].every(Boolean),
            [
                isSponsored,
                !isActive,
                !isTier,
                !isRoundup,
                !isSponsoredArticle,
                !isEmpty,
                !isExisting
            ].every(Boolean)
        ].some(Boolean)
    };
    return placement;
};
/**
 * Generates link and responsive image for the company logo.
 */ var Logo = function(props) {
    var cta = props.cta, companyName = props.companyName, url = props.url, size = props.size, trackingData = props.trackingData;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (sponsorModule_module_default()).logoWrapper,
        href: cta,
        target: "_blank",
        rel: "noreferrer",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage, {
            loading: "lazy",
            altText: "Sponsored by ".concat(companyName),
            url: url,
            mode: "clip",
            mobileWidth: size * 2,
            mobileHeight: size * 2,
            extraProps: trackingData
        })
    });
};
/**
 * Generates the Sponsor Sidebar sometimes called the banner variant.
 */ var SponsorRecircSidebar = function(props) {
    var componentProps = props.componentProps;
    var sponsorWidgetProps = componentProps.sponsorWidgetProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsoredRecircWidget, (0,src_object_spread/* default */.Z)({}, sponsorWidgetProps));
};
/**
 * Generates the Sponsor Footer
 */ var SponsorRecircFooter = function(props) {
    var componentProps = props.componentProps;
    var sponsorWidgetProps = componentProps.sponsorWidgetProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsoredRecircWidget, (0,src_object_spread/* default */.Z)({}, sponsorWidgetProps));
};
/**
 * Generates the Sponsor Midway sometimes called the BIO variant.
 */ var SponsorBio = function(props) {
    var shortName = props.shortName, companyName = props.companyName, logoImage = props.logoImage, legacyId = props.legacyId, description = props.description, cta = props.cta;
    var article = (0,AppContext/* useAppState */.mr)().article;
    var LinkProps = {
        className: (sponsorModule_module_default()).callToAction,
        href: cta
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (sponsorModule_module_default()).iconMediaBlock,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                cta: cta,
                shortName: shortName,
                companyName: companyName,
                url: logoImage,
                size: 75,
                trackingData: {
                    "data-tracking-event-type": "click",
                    "data-tracking-props": JSON.stringify({
                        sp_click_component: "insert",
                        sp_click_component_tile_type: "company_description",
                        sp_click_position: "footer",
                        sp_click_insert_type: "logo",
                        sp_click_target_page_position: "profile",
                        sp_page_type: "content",
                        sp_page_section: "advice",
                        sp_page_company_id: getId(legacyId).toString(),
                        sp_page_entity_id: article.id.toString() || null
                    })
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (sponsorModule_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                        children: [
                            "Sponsored by\xa0",
                            companyName
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
                        type: "richTextBlock",
                        richText: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, LinkProps), {
                        children: [
                            "See Company Profile",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "fa fa-angle-right"
                            })
                        ]
                    }))
                ]
            })
        ]
    });
};
/**
 * Creates one of the 3 sponsor Elements: sidebar, midway, footer
 */ var SponsorElement = function(param) {
    var componentProps = param.componentProps, active = param.active, sponsorLink = param.sponsorLink, shortName = param.shortName, sponsorDescription = param.sponsorDescription, description = param.description, primaryImage = param.primaryImage, secondaryImage = param.secondaryImage, tertiaryImage = param.tertiaryImage, logoImage = param.logoImage, companyName = param.companyName, sponsorName = param.sponsorName, legacyId = param.legacyId, size = param.size, sponsorType = param.sponsorType, id = param.id;
    var moduleTrackingProps = {};
    var cleanProps = {
        active: active,
        cta: sponsorLink || "/profiles/".concat(shortName),
        description: sponsorDescription || description,
        primaryImage: primaryImage,
        secondaryImage: secondaryImage,
        tertiaryImage: tertiaryImage,
        logoImage: logoImage,
        companyName: companyName,
        sponsorName: sponsorName,
        legacyId: legacyId,
        shortName: shortName,
        size: size,
        sponsorType: sponsorType,
        id: id,
        componentProps: componentProps
    };
    if (sponsorType === "midway") {
        moduleTrackingProps = {
            "data-tracking-event-type": "impression",
            "data-tracking-props": JSON.stringify({
                sp_impression_component: "tile",
                sp_impression_tile_type: "company_description",
                sp_impression_position: "footer",
                sp_content_is_tile: false,
                sp_tile_entity_id: getId(legacyId).toString(),
                sp_tile_company_id: getId(legacyId).toString()
            })
        };
    } else if (sponsorType === "sidebar" || sponsorType === "footer") {
        moduleTrackingProps = {
            "data-tracking-event-type": "impression",
            "data-tracking-props": JSON.stringify({
                sp_impression_component: "insert",
                sp_impression_tile_type: null,
                sp_impression_position: "right_rail",
                sp_impression_insert_type: "sponsor_company_jobs",
                sp_content_is_tile: false,
                sp_tile_entity_id: null
            })
        };
    }
    var decisionTree = {
        sidebar: /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorRecircSidebar, (0,src_object_spread/* default */.Z)({}, cleanProps)),
        midway: /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorBio, (0,src_object_spread/* default */.Z)({}, cleanProps)),
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorRecircFooter, (0,src_object_spread/* default */.Z)({}, cleanProps))
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            className: (sponsorModule_module_default())[sponsorType]
        }, moduleTrackingProps), {
            children: decisionTree[sponsorType]
        }))
    });
};
/**
 * Sponsor module business logic: which and if a module should load.
 * See business logic and layout at https://themuse.atlassian.net/l/c/XLUqU116
 * @example
 * import { SponsorModule } from "components/SponsorModule";
 * <SponsorModule {...{ type: "sidebar", ...props }} />
 * <SponsorModule {...{ type: "midway", ...props }} />
 * <SponsorModule {...{ type: "footer", ...props }} />
 */ var SponsorModule = function(props) {
    var active = props.active, hasSponsorShip = props.hasSponsorShip, product = props.product;
    var placements = getSponsorPlacement({
        active: active,
        hasSponsorShip: hasSponsorShip,
        product: product
    });
    var decisionTree = {
        footer: function() {
            return placements.footer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorElement, (0,src_object_spread/* default */.Z)({}, props)) : null;
        },
        sidebar: function() {
            return placements.sidebar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorElement, (0,src_object_spread/* default */.Z)({}, props)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(JobsSidebar, {});
        },
        midway: function() {
            return placements.bio ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorElement, (0,src_object_spread/* default */.Z)({}, props)) : null;
        }
    };
    return decisionTree[props.sponsorType] ? decisionTree[props.sponsorType]() : null;
};

;// CONCATENATED MODULE: ./src/components/SponsorInlineModule.tsx









/**
 * Creates an inline CTA module. This is a content module and is injected in Post process.
 * @example
 * import { SponsorInlineModule } from "components/SponsorInlineModule";
 * <SponsorInlineModule {...MOCK_Sponsor} />
 */ var SponsorInlineModule = function(param) {
    var active = param.active, companyName = param.companyName, hasSponsorShip = param.hasSponsorShip, id = param.id, legacyId = param.legacyId, logoImage = param.logoImage, shortName = param.shortName, product = param.product;
    var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, pilboxHost = _publicRuntimeConfig.pilboxHost, staticAssetHost = _publicRuntimeConfig.staticAssetHost;
    var placements = getSponsorPlacement({
        active: active,
        hasSponsorShip: hasSponsorShip,
        product: product
    });
    var roundupReg = new RegExp("roundup", "i");
    var isRoundup = roundupReg.test(product);
    var encodedUrl = encodeURIComponent("".concat(staticAssetHost, "/").concat(logoImage));
    var flags = "filter=antialias&mode=clip&opt=1&pos=top-left&prog=1&q=keep";
    var logoUrl = "".concat(pilboxHost, "/image.png?").concat(flags, "&url=").concat(encodedUrl, "&h=49&w=108");
    var hasLogo = isRoundup;
    var logoClass = hasLogo ? (sponsorModule_module_default()).sponsorInlineLogo : " ";
    var moduleTrackingProps = {
        "data-oskar-view": "sponsoredCompanyTileViewed",
        "data-oskar-props": JSON.stringify({
            sp_impression_component: "tile",
            sp_impression_tile_type: "article_sponsor",
            sp_impression_position: "in_article",
            sp_page_section: "advice",
            sp_page_type: "content",
            sp_tile_entity_id: legacyId ? legacyId.toString() : null,
            sp_content_is_tile: false
        }),
        "data-tracking-event-type": "impression",
        "data-tracking-props": JSON.stringify({
            sp_impression_component: "tile",
            sp_impression_tile_type: "article_sponsor",
            sp_impression_position: "in_article",
            sp_page_section: "advice",
            sp_page_type: "content",
            sp_tile_entity_id: legacyId ? legacyId.toString() : null,
            sp_content_is_tile: false
        })
    };
    var clickTrackingProps = {
        sp_click_component_tile_type: "article_sponsor",
        sp_click_position: "in_article",
        sp_search_id: null,
        sp_page_type: "content",
        sp_page_section: "advice",
        sp_page_company_id: legacyId ? legacyId.toString() : null,
        sp_page_tab: null,
        sp_is_external_page: false,
        sp_page_entity_id: id
    };
    var profileTrackingProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clickTrackingProps), {
        sp_click_component: "insert",
        sp_click_button_text: null,
        sp_click_target_page_position: "profile",
        sp_click_button_type: null,
        sp_click_insert_type: "logo"
    });
    var searchTrackingProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, clickTrackingProps), {
        sp_click_component: "button",
        sp_click_button_text: "learn more",
        sp_click_target_page_position: "search",
        sp_click_button_type: "job_search",
        sp_click_insert_type: null
    });
    var companyLogoProps = {
        className: (sponsorModule_module_default()).logoPill,
        companyUrl: "/profiles/".concat(shortName),
        altText: "".concat(companyName, " Logo"),
        logoUrl: logoUrl,
        "data-tracking-props": JSON.stringify(profileTrackingProps),
        "data-tracking-event-type": "click"
    };
    var companyLogoTrackingProps = {
        "data-tracking-props": JSON.stringify(profileTrackingProps),
        "data-tracking-event-type": "click"
    };
    var SquareLinkButtonProps = {
        className: (sponsorModule_module_default()).squareButton,
        "data-tracking-props": JSON.stringify(searchTrackingProps),
        "data-tracking-event-type": "click",
        color: "mint",
        href: "/search/company/".concat(shortName),
        target: "_blank"
    };
    return placements.inline ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        className: "".concat((articleContainer_module_default()).contentModule, " ").concat((sponsorModule_module_default()).contentModule, " ").concat((sponsorModule_module_default()).inline, " ").concat(logoClass)
    }, moduleTrackingProps), {
        children: [
            hasLogo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* CompanyLogoOutlined */.uC, (0,src_object_spread/* default */.Z)({
                extraLinkProps: companyLogoTrackingProps
            }, companyLogoProps)) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (sponsorModule_module_default()).sponsorInlineEyebrow,
                children: "EXPLORE JOBS AT"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (sponsorModule_module_default()).sponsorInlineTitle,
                children: companyName
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SquareButton */.LE, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, SquareLinkButtonProps), {
                children: "LEARN MORE"
            }))
        ]
    })) : null;
};

;// CONCATENATED MODULE: ./src/utils/jobQuizConfig.json
var jobQuizConfig_namespaceObject = JSON.parse('{"quizType":"job_quiz","quizId":"quiz","questions":[{"questionId":"category","autoNav":true,"title":"What\'s the best job for you?","details":"Use The Muse to find a job at a company with a culture you love. Select the career path that aligns with you:","field":"keyword","fieldType":"buttonGroup","flow":true,"isRequired":false,"options":[{"display":"Marketing","value":"marketing"},{"display":"Sales","value":"sales"},{"display":"Data","value":"data"},{"display":"Human Resources","value":"human resources"},{"display":"Customer Service","value":"customer service"},{"display":"Software Engineering","value":"software engineering"},{"display":"Product Management","value":"product management"},{"display":"Education","value":"education"},{"display":"Design and UX","value":"design and ux"},{"display":"Administration","value":"administration"}]},{"questionId":"level","autoNav":true,"title":"How many years of experience do you have?","field":"level","fieldType":"buttonGroup","isRequired":false,"options":[{"display":"0 - 1 years","value":"entry"},{"display":"1 - 5 years","value":"mid"},{"display":"5 - 10+ years","value":"senior,executive"}]},{"questionId":"benefits","autoNav":false,"title":"What company benefits are most important to you?","field":"perks","fieldType":"multiSelectButtonGroup","flow":true,"isRequired":false,"options":[{"display":"Health Insurance","value":"health_insurance"},{"display":"Paid Vacation","value":"paid_vacation"},{"display":"Remote Work Opportunities","value":"remote_work_opportunities"},{"display":"Dental Insurance","value":"dental_insurance"},{"display":"401k With Matching","value":"401k_with_matching"},{"display":"Vision Insurance","value":"vision_insurance"},{"display":"Promote From Within","value":"promote_from_within"},{"display":"Flexible Work Hours","value":"flexible_work_hours"},{"display":"Personal Sick Days","value":"personal_sick_days"},{"display":"Performance Bonus","value":"performance_bonus"}]}],"showPrevious":true}');
;// CONCATENATED MODULE: ./src/components/JobQuizModule.tsx








/**
 * Creates an inline CTA module. This is a content module and is injected in Post process.
 * @example
 * import { SponsorInlineModule } from "components/SponsorInlineModule";
 * <SponsorInlineModule {...MOCK_Sponsor} />
 */ var JobQuizModule = function() {
    var article = (0,AppContext/* useAppState */.mr)().article;
    var onQuizSubmit = function(responses) {
        var filtersFromResponses = [];
        responses.questions.forEach(function(elem) {
            var answers = "";
            if (elem.response === null) {
                return;
            }
            if (Array.isArray(elem.response)) {
                answers = elem.response.join();
            } else {
                answers = elem.response;
            }
            filtersFromResponses.push("".concat(elem.field, "=").concat(answers));
        });
        var searchUrl = "/search?".concat(filtersFromResponses.join("&"));
        window.open(searchUrl, "_blank");
    };
    var jobQuizProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, jobQuizConfig_namespaceObject), {
        trackingOverrides: {
            sp_impression_component: "insert",
            sp_impression_insert_type: "job_quiz",
            sp_impression_position: "second_para",
            sp_page_type: "content",
            sp_page_section: "advice",
            sp_page_company_id: null,
            sp_page_tab: null,
            sp_page_is_external: false
        },
        onSubmit: onQuizSubmit
    });
    var excludedUrls = [
        "interview-questions-and-answers"
    ];
    var excludedCategories = [
        "vibe-awards"
    ];
    var showJobQuiz = !excludedUrls.includes(article === null || article === void 0 ? void 0 : article.slug) && !excludedCategories.includes(article === null || article === void 0 ? void 0 : article.categorySlug) && !article.sponsor.id;
    return showJobQuiz ? /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
        className: "".concat((articleContainer_module_default()).contentModule),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* JobQuizContainer */.CX, (0,src_object_spread/* default */.Z)({}, jobQuizProps))
    }) : null;
};

;// CONCATENATED MODULE: ./src/components/ContentMapper.tsx
















var JumpLink = function(props) {
    var id = props.id;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        id: "".concat(id),
        className: "jump-link"
    });
};
/**
 * Returns a heading either h2 or h3.
 * * If position is passed this is a bullet heading and will also contain numbering.
 * * If a prefix is passed we render the prefix before the number.
 * * If a prefix is passed the suffix of the number becomes a colon.
 * * If header is not passed we render nothing.
 * * If size is passed we render an H3.
 */ var HeadingModule = function(props) {
    var prefix = props.prefix, heading = props.heading, position = props.position, size = props.size, headerClassName = props.headerClassName;
    var intro = position ? "".concat(prefix || "", " ").concat(position).concat(prefix ? ": " : ". ").trim() : "";
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            intro.length ? "".concat(intro, " ") : "",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
                className: "inline",
                type: "richTextBlock",
                richText: heading
            })
        ]
    });
    return size ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: headerClassName,
        children: content
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
        className: headerClassName,
        children: content
    });
};
var getResponsiveImage = function(props) {
    var _alignment = props.alignment, alignment = _alignment === void 0 ? "left" : _alignment, image = props.image;
    var height = image.height, width = image.width, url = image.url, altText = image.altText, credit = image.credit, creditLink = image.creditLink;
    // Because caption can be overwritten in the template.
    var caption = props.caption || image.caption || "";
    var aspect = height / width;
    var sizes = {
        xs: 313,
        sm: 630,
        md: 630,
        lg: 515,
        xl: 780
    };
    var mobileWidth = Math.ceil(width >= sizes.xs ? sizes.xs : width);
    var tabletWidth = Math.ceil(width >= sizes.sm ? sizes.sm : width);
    var laptopWidth = Math.ceil(width >= sizes.md ? sizes.md : width);
    var desktopWidth = Math.ceil(width >= sizes.lg ? sizes.lg : width);
    var bigScreenWidth = Math.ceil(width >= sizes.xl ? sizes.xl : width);
    var mobileHeight = Math.ceil(mobileWidth * aspect);
    var tabletHeight = Math.ceil(tabletWidth * aspect);
    var laptopHeight = Math.ceil(laptopWidth * aspect);
    var desktopHeight = Math.ceil(desktopWidth * aspect);
    var bigScreenHeight = Math.ceil(bigScreenWidth * aspect);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
        className: "".concat((responsiveImageModule_module_default()).articleBodyImageModule, " ").concat((responsiveImageModule_module_default())["pull".concat(alignment)]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (responsiveImageModule_module_default()).imageWrapper,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage, {
                altText: altText,
                bigScreenHeight: bigScreenHeight,
                bigScreenWidth: bigScreenWidth,
                caption: caption,
                credit: credit,
                creditLink: creditLink,
                desktopHeight: desktopHeight,
                desktopWidth: desktopWidth,
                laptopHeight: laptopHeight,
                laptopWidth: laptopWidth,
                loading: "lazy",
                mobileHeight: mobileHeight,
                mobileWidth: mobileWidth,
                tabletHeight: tabletHeight,
                tabletWidth: tabletWidth,
                url: url
            })
        })
    });
};
// The following linter issue is a bug in eslint
// eslint-disable-next-line no-undef
var ContentMapper = function(props) {
    var _modules = props.modules, modules = _modules === void 0 ? [] : _modules, hasBullets = props.hasBullets, prefix = props.prefix, tocEntities = props.tocEntities;
    var hasDividers = modules && modules.some(function(module) {
        return module && module.type === "divider";
    });
    var position = 0;
    var companyOrder = 0;
    var annotatedModules = modules.map(function(module) {
        if (module.type === "companyProfileBlock") {
            companyOrder += 1;
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, module), {
                orderNum: companyOrder
            });
        }
        return module;
    });
    return annotatedModules.map(function(module) {
        var heading = module.heading, type = module.type, id = module.id, inToc = module.inToc;
        var size = !hasDividers || type === "divider";
        var hasBullet = !!heading && type !== "divider";
        var headerClassName = props.templateName === "listicle" ? "listicle-header" : null;
        position = hasBullets && hasBullet ? position + 1 : position;
        var HeadingProps = {
            prefix: hasBullets && hasBullet ? prefix : "",
            position: hasBullet ? position : 0,
            size: size,
            heading: heading,
            id: id,
            headerClassName: headerClassName
        };
        var content = {
            richTextBlock: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, (0,src_object_spread/* default */.Z)({}, moduleProps));
            },
            blockquoteBlock: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockQuoteModule, (0,src_object_spread/* default */.Z)({}, moduleProps));
            },
            htmlBlock: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlModule, (0,src_object_spread/* default */.Z)({}, moduleProps));
            },
            embedBlock: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmbedModule, (0,src_object_spread/* default */.Z)({
                    template: "article"
                }, moduleProps));
            },
            jwVideoBlock: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JWVideoModule, (0,src_object_spread/* default */.Z)({}, moduleProps));
            },
            companyProfileBlock: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyModule, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, moduleProps), {
                    isArticle: !hasBullets,
                    orderNum: module.orderNum
                }));
            },
            divider: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerModule, (0,src_object_spread/* default */.Z)({}, moduleProps));
            },
            imageBlock: getResponsiveImage,
            tocGenerator: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TocModule, (0,src_object_spread/* default */.Z)({
                    entities: tocEntities
                }, moduleProps));
            },
            sponsorInlineBlock: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorInlineModule, (0,src_object_spread/* default */.Z)({}, moduleProps));
            },
            jobQuizBlock: function(moduleProps) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobQuizModule, (0,src_object_spread/* default */.Z)({}, moduleProps));
            }
        };
        return content[module.type] && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                inToc && /*#__PURE__*/ (0,jsx_runtime.jsx)(JumpLink, {
                    id: id
                }),
                heading && module.type !== "divider" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingModule, (0,src_object_spread/* default */.Z)({}, HeadingProps)),
                " ",
                content[module.type](module)
            ]
        }, id);
    });
};

;// CONCATENATED MODULE: ./src/components/ArticleBody.tsx



var ArticleBody = function(props) {
    var articleContentModules = props.articleContentModules, blockHeadingPrefix = props.blockHeadingPrefix, listBuilder = props.listBuilder, postListBodyContent = props.postListBodyContent, templateName = props.templateName, tocEntities = props.tocEntities;
    var contentProps = {
        modules: articleContentModules,
        templateName: templateName,
        tocEntities: tocEntities
    };
    var listBuilderProps = {
        modules: listBuilder,
        templateName: templateName,
        hasBullets: true,
        prefix: blockHeadingPrefix
    };
    var postBodyProps = {
        modules: postListBodyContent,
        templateName: templateName
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ContentMapper(contentProps),
            listBuilder && ContentMapper(listBuilderProps),
            postListBodyContent && ContentMapper(postBodyProps)
        ]
    });
};


// EXTERNAL MODULE: ./src/components/authorModule.module.scss
var authorModule_module = __webpack_require__(6349);
var authorModule_module_default = /*#__PURE__*/__webpack_require__.n(authorModule_module);
;// CONCATENATED MODULE: ./src/components/AuthorModule.tsx








/**
 * Creates an author block.  Accepts small or large to decide if this is a sidebar or footer block.
 * @example
 * <AuthorModule
 *     biography={props.contentAuthor.biography}
 *     email={props.contentAuthor.email}
 *     headshotUrl={props.contentAuthor.headshotUrl}
 *     writerName={props.contentAuthor.writerName}
 *     writerSlug={props.contentAuthor.writerSlug}
 * />
 */ var AuthorModule = function(param) {
    var biography = param.biography, headshotUrl = param.headshotUrl, writerName = param.writerName, writerSlug = param.writerSlug;
    var wrapperClass = "".concat((articleContainer_module_default()).contentModule, " ").concat((authorModule_module_default()).author);
    var writerUri = "/author/".concat(writerSlug);
    var bioImageDimensions = {
        mobileWidth: 76,
        mobileHeight: 76,
        tabletWidth: 108,
        tabletHeight: 108
    };
    return !writerName ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
            className: wrapperClass,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                    className: (authorModule_module_default()).headshot,
                    href: writerUri,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveImage, (0,src_object_spread/* default */.Z)({
                        loading: "lazy",
                        round: true,
                        altText: writerName,
                        url: headshotUrl
                    }, bioImageDimensions))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (authorModule_module_default()).bio,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextModule, {
                            type: "richTextBlock",
                            richText: biography
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                            className: "".concat((authorModule_module_default()).readMore, " ").concat((authorModule_module_default()).callToAction),
                            href: writerUri,
                            children: [
                                "More from\xa0",
                                writerName,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "fa fa-angle-right"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/ArticleContent.tsx








var ArticleContent = function(props) {
    var articleContentModules = props.articleContentModules, blockHeadingPrefix = props.blockHeadingPrefix, listBuilder = props.listBuilder, postListBodyContent = props.postListBodyContent, sponsorModuleProps = props.sponsorModuleProps, templateName = props.templateName, author = props.author;
    // tocEntities is a collection of all the objects passed to the article in each of the 3 sections.
    // These are used only in the first section to discover the needed elements from the full page to build a TOC.
    var tocEntities = getTOCEntries([].concat(articleContentModules, listBuilder, postListBodyContent));
    var bodyProps = {
        articleContentModules: articleContentModules,
        blockHeadingPrefix: blockHeadingPrefix,
        listBuilder: listBuilder,
        postListBodyContent: postListBodyContent,
        templateName: templateName,
        tocEntities: tocEntities
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (articleContainer_module_default()).articleContent,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (articleContainer_module_default()).contentModule,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleBody, (0,src_object_spread/* default */.Z)({}, bodyProps)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorModule, (0,src_object_spread/* default */.Z)({
                    sponsorType: "footer"
                }, sponsorModuleProps)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthorModule, (0,src_object_spread/* default */.Z)({}, author))
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/hooks/useLocalStorage.tsx


function useLocalStorage(key) {
    if (!(0,browser/* isBrowser */.jU)()) {
        return [
            null,
            function() {}
        ];
    }
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    var ref = (0,react.useState)(function() {
        // Get from local storage by key
        var item = window.localStorage.getItem(key);
        return item || "";
    }), storedValue = ref[0], setStoredValue = ref[1];
    // Return a wrapped version of useState's setter function that
    // persists the new value to localStorage.
    var setValue = function(value) {
        // Save state
        setStoredValue(value);
        // Save to local storage
        window.localStorage.setItem(key, value);
    };
    return [
        storedValue,
        setValue
    ];
}

;// CONCATENATED MODULE: ./src/components/Newsletter.tsx










var Newsletter = function() {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showNewsletter = ref[0], setShowNewsletter = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showFormModal = ref1[0], setShowFormModal = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(useLocalStorage("newsletter_subscription"), 2), userHasSubscribed = ref2[0], setUserHasSubscribed = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(useLocalStorage("newsletter_form_closed"), 2), lastClosedForm = ref3[0], setLastClosedForm = ref3[1];
    var oneDayMilliseconds = 86400000;
    var newsletterHashExists = window.location.hash === "#newsletter";
    var formNotClosedInLast24Hours = Date.now() - (Date.parse(lastClosedForm) || 0) > oneDayMilliseconds;
    react.useEffect(function() {
        if (formNotClosedInLast24Hours && !userHasSubscribed || newsletterHashExists) {
            setShowNewsletter(true);
            var delay = 5000;
            if (newsletterHashExists) {
                delay = 500;
            }
            var timer = setTimeout(function() {
                setShowFormModal(true);
            }, delay);
            return function() {
                return clearTimeout(timer);
            };
        }
        return function() {};
    }, []);
    var onNewsletterRefChange = function(node) {
        if (node && !userHasSubscribed) {
            (0,build/* triggerSnowplowImpressionEvent */.XQ)(node);
        }
    };
    var onSuccessRefChange = function(node) {
        if (node && userHasSubscribed) {
            (0,build/* triggerSnowplowImpressionEvent */.XQ)(node);
        }
    };
    var handleModalFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(formData) {
            var newsletterSuccess;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,api/* newsletterSubscribeRequest */.Pl)(formData);
                    case 2:
                        newsletterSuccess = _ctx.sent;
                        if (newsletterSuccess) {
                            setUserHasSubscribed("true");
                            setShowFormModal(false);
                        }
                        return _ctx.abrupt("return", newsletterSuccess);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleModalFormSubmit(formData) {
            return _ref.apply(this, arguments);
        };
    }();
    var newsletterProps = {
        handleModalFormClose: function() {
            setLastClosedForm(new Date().toISOString());
            setShowFormModal(false);
        },
        handleModalFormSubmit: handleModalFormSubmit,
        showFormModal: showFormModal,
        newsletterRef: onNewsletterRefChange,
        successRef: onSuccessRefChange
    };
    return showNewsletter ? /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* NewsletterModal */.d1, (0,src_object_spread/* default */.Z)({}, newsletterProps)) : null;
};


;// CONCATENATED MODULE: ./src/components/EmailCapture.tsx





/* eslint-disable @typescript-eslint/no-unused-vars */ var EmailCapture = function(props) {
    var slug = props.slug, templateName = props.templateName;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), emailCaptureReady = ref[0], setEmailCaptureReady = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showNewsletter = ref1[0], setShowNewsletter = ref1[1];
    var shouldNewsletterShow = function() {
        switch(templateName){
            case "companyLanding":
                {
                    return true;
                }
            case "landing":
            case "listicle":
            case "article":
                {
                    // check slugs
                    if (constants/* NEWSLETTER_EXCLUDED_PAGES.some */.oH.some(function(x) {
                        return x === slug;
                    })) {
                        return false;
                    }
                    break;
                }
            default:
                {
                    break;
                }
        }
        return true;
    };
    react.useEffect(function() {
        setShowNewsletter(shouldNewsletterShow());
        setEmailCaptureReady(true);
    }, []);
    if (!emailCaptureReady) {
        return null;
    }
    if (showNewsletter) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Newsletter, {});
    }
    return null;
};


// EXTERNAL MODULE: ./src/components/RecentArticles.module.scss
var RecentArticles_module = __webpack_require__(8318);
var RecentArticles_module_default = /*#__PURE__*/__webpack_require__.n(RecentArticles_module);
;// CONCATENATED MODULE: ./src/components/RecentArticles.tsx












// Base tracking props common across all tiles.
var trackingProps = {
    // SnowplowClickEventProps
    sp_click_button_type: null,
    sp_click_component: "tile",
    sp_click_component_tile_type: "article",
    sp_click_insert_type: null,
    sp_click_search_id: null,
    sp_click_target_page_section: "advice",
    // SnowplowTileContentProps
    sp_tile_entity_uuid: "",
    sp_tile_location: "recent_articles",
    sp_tile_type: "article",
    // SnowplowImpressionProps
    sp_impression_component: "tile",
    sp_impression_tile_type: "article",
    sp_impression_insert_type: null,
    sp_impression_modal_type: null,
    sp_impression_button_type: null,
    sp_impression_search_id: null,
    sp_impression_position: "bottom"
};
// Generated the tracking props for each tile.
var getTrackingProps = function(article, index) {
    var ref;
    var id = article.id, companySponsor = article.companySponsor;
    var ref1, ref2;
    var props = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, trackingProps), {
        // SnowplowClickEventProps
        sp_click_button_text: null,
        sp_click_link_text: article.title,
        sp_click_position: "bottom",
        // SnowplowTileContentProps
        sp_tile_company_id: (ref1 = companySponsor === null || companySponsor === void 0 ? void 0 : (ref = companySponsor.id) === null || ref === void 0 ? void 0 : ref.toString()) !== null && ref1 !== void 0 ? ref1 : "",
        sp_tile_entity_id: (ref2 = id.toString()) !== null && ref2 !== void 0 ? ref2 : "",
        sp_tile_order: index
    });
    return props;
};
// Generates an individual tile.
var ArticleTile = function(props) {
    var ref;
    var article = props.article, index = props.index;
    var leadMediaPhoto = article.leadMediaPhoto, title = article.title, uri = article.uri, writer = article.writer;
    var writerName = writer.writerName;
    var ref1 = (0,config["default"])(), staticAssetHost = ref1.publicRuntimeConfig.staticAssetHost;
    var ref2;
    // url text could be null and lead media might not exist
    var url = (ref2 = leadMediaPhoto === null || leadMediaPhoto === void 0 ? void 0 : (ref = leadMediaPhoto[0]) === null || ref === void 0 ? void 0 : ref.url) !== null && ref2 !== void 0 ? ref2 : "".concat(staticAssetHost, "/media/lead/placeholder.png");
    var ref3 = react.useRef();
    var tileObserver = getObserver(function(element) {
        return (0,build/* triggerSnowplowImpressionEvent */.XQ)(element);
    });
    react.useEffect(function() {
        tileObserver.observe(ref3.current);
        return function() {
            tileObserver.disconnect();
        };
    }, []);
    var tileTrackingProps = getTrackingProps(article, index);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: (RecentArticles_module_default()).RecentTile,
        ref: ref3,
        "data-tracking-props": JSON.stringify(tileTrackingProps),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (RecentArticles_module_default()).linkWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (RecentArticles_module_default()).image,
                    height: "111",
                    width: "111",
                    alt: "",
                    loading: "lazy",
                    src: "https://pilbox.themuse.com/image.jpg?filter=antialias&opt=1&mode=crop&pos=center&prog=1&q=keep&url=".concat(url, "&w=111&h=111")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (RecentArticles_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (RecentArticles_module_default()).author,
                            children: writerName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (RecentArticles_module_default()).title,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/".concat(uri),
                                onClick: function(e) {
                                    return (0,build/* triggerSnowplowClickEvent */.jL)((0,src_object_spread/* default */.Z)({}, e, tileTrackingProps));
                                },
                                children: title
                            })
                        })
                    ]
                })
            ]
        })
    });
};
// The main component with all tiles.
var RecentArticles = function(props) {
    var primaryTopic = props.primaryTopic;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(primaryTopic.slug), 2), topic = ref[0], setTopic = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), articles = ref1[0], setArticles = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState("Recent Articles in ".concat(primaryTopic.title)), 2), outerHeading = ref3[0], setOuterHeading = ref3[1];
    var ref4 = (0,config["default"])(), _publicRuntimeConfig = ref4.publicRuntimeConfig, staticAssetHost = _publicRuntimeConfig.staticAssetHost, appName = _publicRuntimeConfig.appName, apiRequestTimeoutMs = _publicRuntimeConfig.apiRequestTimeoutMs;
    var fetchRecentArticles = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var url;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        url = "".concat(staticAssetHost, "/recent-articles/").concat(topic, ".json");
                        return _ctx.abrupt("return", axios_default().get(url, {
                            method: "GET",
                            timeout: apiRequestTimeoutMs,
                            headers: {
                                "content-type": "application/json;charset=UTF-8"
                            }
                        }).then(function(response) {
                            var ref;
                            var data = response.data;
                            // Filter out the current url and include a maximum of 6.
                            var list = data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
                                return !window.location.pathname.includes(x.uri);
                            }).slice(0, 6);
                            // If we still have any articles lets render them.
                            if (list.length) {
                                setArticles(list);
                                setIsLoading(false);
                                return true;
                            }
                            // Not enough data, but not really an error, let's warn people.
                            console.warn("".concat(appName, " received insufficient data from ").concat(url));
                            // Update the state so we can fetch the fallback data.
                            setTopic("most_recent");
                            setIsLoading(false);
                            setOuterHeading("Recent Articles");
                            return false;
                        }).catch(function(error) {
                            if (topic === "most_recent") {
                                // Yikes! The fallback data is bad too? Let's be noisy.
                                console.error(error);
                                return false;
                            }
                            // Ok the first url is bad but we can setup for the fallback data here too.
                            setTopic("most_recent");
                            setOuterHeading("Recent Articles");
                            setIsLoading(false);
                            return true;
                        }));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchRecentArticles() {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        fetchRecentArticles();
    }, [
        topic
    ]);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
            "data-msg": "not ready",
            children: "Loading ..."
        });
    }
    if (!isLoading && !(articles === null || articles === void 0 ? void 0 : articles.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
            "data-msg": "no data"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        className: (RecentArticles_module_default()).RecentArticles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (RecentArticles_module_default()).RecentArticlesHeading,
                children: outerHeading
            }),
            articles.map(function(article, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleTile, {
                    article: article,
                    index: index + 1
                }, article.uri);
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/ArticleContainer.tsx



/* eslint-disable @typescript-eslint/no-unused-vars */ 










var ArticleContainer = function() {
    var article = (0,AppContext/* useAppState */.mr)().article;
    var articleContentModules = article.articleContentModules, articleUri = article.articleUri, blockHeadingPrefix = article.blockHeadingPrefix, breadcrumbLinks = article.breadcrumbLinks, contentAuthor = article.contentAuthor, leadMedia = article.leadMedia, listBuilder = article.listBuilder, listicleContentType = article.listicleContentType, postListBodyContent = article.postListBodyContent, product = article.product, slug = article.slug, sponsor = article.sponsor, tags = article.tags, templateName = article.templateName, title = article.title, componentProps = article.componentProps, dateUpdated = article.dateUpdated, postDate = article.postDate, primaryTopic = article.primaryTopic;
    var social = {
        articleUri: articleUri,
        slug: slug,
        title: title,
        writerName: contentAuthor === null || contentAuthor === void 0 ? void 0 : contentAuthor.writerName,
        writerSlug: contentAuthor === null || contentAuthor === void 0 ? void 0 : contentAuthor.writerSlug,
        twitterHandle: contentAuthor === null || contentAuthor === void 0 ? void 0 : contentAuthor.twitterHandle,
        dateUpdated: postDate > dateUpdated ? postDate : dateUpdated
    };
    var author = (0,src_object_spread/* default */.Z)({
        articleUri: articleUri,
        slug: slug,
        title: title
    }, contentAuthor);
    var sponsorModuleProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        listicleContentType: listicleContentType,
        tags: tags,
        product: product
    }, sponsor), {
        componentProps: componentProps
    });
    var articleContentProps = {
        articleContentModules: articleContentModules,
        postListBodyContent: postListBodyContent,
        blockHeadingPrefix: blockHeadingPrefix,
        listBuilder: listBuilder,
        templateName: templateName,
        sponsorModuleProps: (0,src_object_spread/* default */.Z)({}, sponsorModuleProps),
        author: author,
        dateUpdated: dateUpdated,
        postDate: postDate
    };
    var FEATURE_FLAG_NEWSLETTER_MODAL = useFeatureFlagsState().FEATURE_FLAG_NEWSLETTER_MODAL;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (articleContainer_module_default()).article,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (articleContainer_module_default()).articleContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleHeader, {
                        articleTitle: title,
                        breadcrumbs: breadcrumbLinks
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (articleContainer_module_default()).articleBannerFlexContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (articleContainer_module_default()).articleBody,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorModule, (0,src_object_spread/* default */.Z)({
                                    sponsorType: "sidebar"
                                }, sponsorModuleProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSocial, (0,src_object_spread/* default */.Z)({}, social)),
                                leadMedia && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeadMediaModule, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, leadMedia), {
                                    showPinterest: true
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContent, (0,src_object_spread/* default */.Z)({}, articleContentProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SponsorModule, (0,src_object_spread/* default */.Z)({
                                    sponsorType: "midway"
                                }, sponsorModuleProps)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentArticles, {
                                    primaryTopic: primaryTopic
                                })
                            ]
                        })
                    })
                ]
            }),
            FEATURE_FLAG_NEWSLETTER_MODAL && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailCapture, (0,src_object_spread/* default */.Z)({}, article))
        ]
    });
};

;// CONCATENATED MODULE: ./src/hooks/subNavStatic.ts
var subNavItems = {
    items: [
        {
            title: "Job Search",
            uri: "/advice/job-search",
            children: [
                {
                    title: "Finding a Job",
                    uri: "/advice/finding-a-job"
                },
                {
                    title: "Resumes",
                    uri: "/advice/resumes",
                    children: [
                        {
                            title: "Resume Examples",
                            uri: "/advice/resume-examples"
                        }
                    ]
                },
                {
                    title: "Cover Letters",
                    uri: "/advice/cover-letters"
                },
                {
                    title: "Networking",
                    uri: "/advice/networking"
                },
                {
                    title: "Interviewing",
                    uri: "/advice/interviewing"
                },
                {
                    title: "Job Offer",
                    uri: "/advice/job-offer"
                }
            ]
        },
        {
            title: "Career Paths",
            uri: "/advice/career-paths",
            children: [
                {
                    title: "Exploring Careers",
                    uri: "/advice/exploring-careers",
                    children: [
                        {
                            title: "Careers in Data and Analytics",
                            uri: "/advice/data-science-analytics"
                        },
                        {
                            title: "Careers in Finance",
                            uri: "/advice/finance"
                        },
                        {
                            title: "Careers in Marketing",
                            uri: "/advice/marketing"
                        },
                        {
                            title: "Careers in Sales",
                            uri: "/advice/sales"
                        },
                        {
                            title: "Careers in Software Engineering",
                            uri: "/advice/software-engineering"
                        }
                    ]
                },
                {
                    title: "Career Stories",
                    uri: "/advice/career-stories"
                },
                {
                    title: "Career Change",
                    uri: "/advice/career-change"
                },
                {
                    title: "Training and Development",
                    uri: "/advice/training-development"
                }
            ]
        },
        {
            title: "Succeeding at Work",
            uri: "/advice/succeeding-at-work",
            children: [
                {
                    title: "Work and COVID-19",
                    uri: "/advice/work-and-coronavirus-covid-19"
                },
                {
                    title: "Productivity",
                    uri: "/advice/productivity"
                },
                {
                    title: "Getting Ahead",
                    uri: "/advice/getting-ahead"
                },
                {
                    title: "Work Relationships",
                    uri: "/advice/work-relationships"
                },
                {
                    title: "Work-Life Balance",
                    uri: "/advice/work-life-balance",
                    children: [
                        {
                            title: "Working Parents",
                            uri: "/advice/working-parents"
                        },
                        {
                            title: "Remote Work",
                            uri: "/advice/remote-work"
                        }
                    ]
                },
                {
                    title: "Money",
                    uri: "/advice/money"
                },
                {
                    title: "Changing Jobs",
                    uri: "/advice/changing-jobs"
                },
                {
                    title: "Management",
                    uri: "/advice/management"
                },
                {
                    title: "Break Room",
                    uri: "/advice/break-room"
                }
            ]
        },
        {
            title: "Diversity and Inclusion",
            uri: "/advice/diversity-inclusion",
            children: [
                {
                    title: "Anti-Racism at Work",
                    uri: "/advice/anti-racism-at-work"
                },
                {
                    title: "LGBTQ at Work",
                    uri: "/advice/lgbtq-at-work"
                },
                {
                    title: "Disability and Work",
                    uri: "/advice/disability-and-work"
                },
                {
                    title: "Gender and Work",
                    uri: "/advice/gender-and-work"
                }
            ]
        },
        {
            title: "More",
            uri: "",
            children: [
                {
                    title: "Videos",
                    uri: "/advice/videos",
                    children: [
                        {
                            title: "Job Search Videos",
                            uri: "/advice/job-search-videos"
                        },
                        {
                            title: "Career Advice Videos",
                            uri: "/advice/career-advice-videos"
                        },
                        {
                            title: "Career Story Videos",
                            uri: "/advice/career-story-videos"
                        },
                        {
                            title: "Company Spotlight Videos",
                            uri: "/advice/company-spotlight-videos"
                        },
                        {
                            title: "Industry Spotlight Videos",
                            uri: "/advice/industry-spotlight-videos"
                        }
                    ]
                },
                {
                    title: "Employer Resources",
                    uri: "/advice/employer-resources"
                }
            ]
        }
    ]
};

// EXTERNAL MODULE: ./src/components/subNav.module.scss
var subNav_module = __webpack_require__(8621);
var subNav_module_default = /*#__PURE__*/__webpack_require__.n(subNav_module);
;// CONCATENATED MODULE: ./src/components/SubNav.tsx

/* eslint no-use-before-define: ["error", { "variables": false }] */ 



/**
 * Is the current elements title contained within the breadcrumb list.
 */ var isActive = function() {
    var breadCrumbs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], title = arguments.length > 1 ? arguments[1] : void 0;
    var str = (breadCrumbs === null || breadCrumbs === void 0 ? void 0 : breadCrumbs.some(function(crumb) {
        var ref;
        return (crumb === null || crumb === void 0 ? void 0 : (ref = crumb.title) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (title === null || title === void 0 ? void 0 : title.toLowerCase());
    })) ? (subNav_module_default()).subNavActive : "";
    return str;
};
var getLinkOrText = function(title, uri, activeClass) {
    var textClass = "".concat((subNav_module_default()).linkText, " ").concat(activeClass);
    if (uri) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (subNav_module_default()).navLink,
            href: uri,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: textClass,
                children: title
            })
        });
    }
    // adding tabIndex here so that this item can gain focus.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (subNav_module_default()).navLink,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: textClass,
            children: title
        })
    });
};
/**
 * Gets the list of fly-out elements.
 */ var getChildren = function(items) {
    var breadCrumbs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], isGrandChild = arguments.length > 2 ? arguments[2] : void 0;
    var children = items.length ? items.map(function(item) {
        return getChild(item, breadCrumbs, isGrandChild);
    }) : null;
    return children;
};
/**
 * Renders the top level nav items.
 */ var getTopMenu = function() {
    var items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], breadCrumbs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return items.map(function(item) {
        var uri = item.uri, title = item.title, children = item.children;
        var activeClass = isActive(breadCrumbs, title);
        var allLink = uri ? getLinkOrText("View all in ".concat(title, " >"), uri, "") : null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            role: "menuitem",
            className: (subNav_module_default()).menuItem,
            tabIndex: 0,
            children: [
                getLinkOrText(title, "", activeClass),
                children && children.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    role: "menu",
                    className: (subNav_module_default()).menuGroup,
                    children: [
                        getChildren(children, breadCrumbs),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (subNav_module_default()).menuTitle,
                            children: allLink
                        })
                    ]
                }) : null
            ]
        }, title);
    });
};
/**
 * Renders the fly-outs
 */ var getChild = function(item) {
    var breadCrumbs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], isGrandChild = arguments.length > 2 ? arguments[2] : void 0;
    var uri = item.uri, title = item.title, children = item.children;
    var activeClass = isActive(breadCrumbs, title);
    var nestedClass = isGrandChild ? (subNav_module_default()).menuItemNested : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                role: "menuitem",
                className: nestedClass,
                children: getLinkOrText(title, uri, activeClass)
            }),
            children && children.length ? getChildren(children, breadCrumbs, true) : null
        ]
    }, title);
};
/**
 * Renders a SubNav module
 */ var SubNav = function() {
    var ref = (0,AppContext/* useAppState */.mr)(), article = ref.article, pathName = ref.pageMetaData.pathName;
    var breadCrumbs = article === null || article === void 0 ? void 0 : article.breadcrumbLinks;
    var crumb = (article === null || article === void 0 ? void 0 : article.breadcrumbLink) || undefined;
    var items = subNavItems.items;
    var page = {
        title: (article === null || article === void 0 ? void 0 : article.title) || "",
        uri: pathName
    };
    if (crumb) {
        breadCrumbs.push(crumb);
    }
    // the page should always be last.
    breadCrumbs.push(page);
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
    /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        role: "menubar",
        className: (subNav_module_default()).subNav,
        "aria-label": "Sub Navigation",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            role: "menu",
            className: (subNav_module_default()).menu,
            children: getTopMenu(items, breadCrumbs)
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(5935);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/SEO.tsx


/* eslint-disable max-len */ 





var organization = {
    "@type": "Organization",
    description: "The Muse is the go-to destination for people to research everything they need to know about companies and careers.",
    logo: {
        "@type": "ImageObject",
        url: "https://assets.themuse.com/uploaded/companies/1327/small_logo.png?v=1664489768",
        description: "The Muse",
        width: 668,
        height: 296
    },
    legalName: "Daily Muse Inc.",
    name: "The Muse",
    sameAs: [
        "https://www.facebook.com/thedailymuse",
        "https://twitter.com/TheMuse",
        "https://www.instagram.com/themuse/",
        "https://www.youtube.com/channel/UCk4bbQAZD26f_XdGyb4wwhg",
        "https://www.linkedin.com/company/the-daily-muse/",
        "https://en.wikipedia.org/wiki/The_Muse_(website)",
        "https://www.pinterest.com/thedailymuse/",
        "https://www.tiktok.com/@themuse_",
        "https://www.threads.net/@themuse"
    ],
    url: "https://www.themuse.com",
    address: {
        "@type": "PostalAddress",
        streetAddress: "1375 Broadway, 20th Floor",
        addressLocality: "New York",
        addressRegion: "NY",
        postalCode: 10018,
        addressCountry: "US"
    }
};
/**
 * Generates the open graph object.
 * @returns an Object
 */ var genOpenGraphJSON = function(props) {
    var author = props.author, canonical = props.canonical, description = props.description, leadMediaAlt = props.leadMediaAlt, leadMediaHeight = props.leadMediaHeight, leadMediaUrl = props.leadMediaUrl, leadMediaWidth = props.leadMediaWidth, modifiedTime = props.modifiedTime, postDate = props.postDate, title = props.title;
    return {
        title: title,
        description: description,
        url: canonical,
        type: "article",
        site_name: "The Muse",
        locale: "en_US",
        article: {
            publishedTime: postDate,
            modifiedTime: modifiedTime,
            authors: [
                author
            ]
        },
        images: [
            {
                alt: leadMediaAlt,
                url: leadMediaUrl,
                width: leadMediaWidth,
                height: leadMediaHeight
            }
        ]
    };
};
/**
 * Generates the Twitter object passed into NextSEO.
 * @returns an Object
 */ var genTwitterJSON = function() {
    return {
        handle: "@TheMuse",
        site: "@TheMuse",
        cardType: "summary_large_image"
    };
};
/**
 * Generates the article schema object passed into LD+Json.
 * @returns an Object
 */ var genArticleJSON = function(props) {
    var canonical = props.canonical, description = props.description, leadMediaUrl = props.leadMediaUrl, modifiedTime = props.modifiedTime, postDate = props.postDate, title = props.title, writerName = props.writerName, author = props.author;
    return {
        "@context": "https://schema.org",
        "@type": "Article",
        datePublished: postDate,
        description: description,
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": "".concat(canonical)
        },
        headline: title,
        image: {
            "@type": "ImageObject",
            url: leadMediaUrl,
            width: 820,
            height: 430
        },
        dateModified: modifiedTime,
        author: [
            {
                "@type": "Person",
                name: writerName,
                url: author
            }
        ],
        publisher: organization
    };
};
/**
 * Generates the breadcrumb schema object passed into LD+Json.
 * @returns an Object
 */ var genBreadcrumbJSON = function(breadcrumbLinks) {
    var cleanCrumbs = breadcrumbLinks.filter(function(x) {
        return x.title && x.uri;
    });
    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: cleanCrumbs.map(function(x, i) {
            return {
                "@type": "ListItem",
                position: i + 1,
                item: {
                    "@id": "https://www.themuse.com/".concat(x.uri),
                    name: /^advice$/i.test(x.title) ? "Advice" : x.title
                }
            };
        })
    };
};
/**
 * Generates the organization schema object passed into LD+Json.
 * @returns an Object
 */ var genOrganizationJSON = function() {
    return (0,src_object_spread/* default */.Z)({
        "@context": "https://schema.org"
    }, organization);
};
/**
 * Generates the SEO data for the head both LD+JSON and MetaData links.
 * @returns React.ReactElement
 */ var SEO = function(props) {
    var ref = (0,config["default"])(), museHost = ref.publicRuntimeConfig.museHost;
    var articleUri = props.articleUri, canonical = props.canonical, breadcrumbLinks = props.breadcrumbLinks, dateUpdated = props.dateUpdated, description = props.description, leadMedia = props.leadMedia, postDate = props.postDate, primaryTopic = props.primaryTopic, seo = props.seo, title = props.title, writerName = props.writerName, writerUri = props.writerUri;
    var ref1 = leadMedia || {}, altText = ref1.altText, url = ref1.url;
    var modifiedTime = postDate > dateUpdated ? postDate : dateUpdated;
    var author = "".concat(museHost, "/").concat(writerUri);
    var includeAmp = !constants/* AMP_EXCLUDED_ARTICLES.includes */.hL.includes(articleUri);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: canonical
                    }, "canonical"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    }, "robots"),
                    (0,html_react_parser/* default */.ZP)(seo.MetaTitleContainer),
                    (0,html_react_parser/* default */.ZP)(seo.MetaTagContainer),
                    includeAmp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "amphtml",
                        href: "".concat(museHost, "/amp/").concat(articleUri)
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:alt",
                        content: altText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:author",
                        content: author
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:modified_time",
                        content: modifiedTime
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:published_time",
                        content: postDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:section",
                        content: "Advice"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "article:tag",
                        content: primaryTopic.title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                id: "Article-JSON",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(genArticleJSON({
                        canonical: canonical,
                        description: description,
                        leadMediaUrl: url,
                        modifiedTime: modifiedTime,
                        postDate: postDate,
                        title: title,
                        writerName: writerName,
                        author: author
                    }))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                id: "BreadcrumbList-JSON",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(genBreadcrumbJSON(breadcrumbLinks))
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                strategy: "beforeInteractive",
                id: "Organization-JSON",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(genOrganizationJSON())
                }
            })
        ]
    });
};
// WARNING: These are for unit testing only and should NEVER be used directly outside this file.
var openGraphJSONTestingOnly = (/* unused pure expression or super */ null && (genOpenGraphJSON));
var twitterJSONTestingOnly = (/* unused pure expression or super */ null && (genTwitterJSON));
var articleJSONTestingOnly = (/* unused pure expression or super */ null && (genArticleJSON));
var breadcrumbJSONTestingOnly = (/* unused pure expression or super */ null && (genBreadcrumbJSON));
var organizationJSONTestingOnly = (/* unused pure expression or super */ null && (genOrganizationJSON));


// EXTERNAL MODULE: ./src/styles/Home.module.scss
var Home_module = __webpack_require__(4865);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./src/pages/index.tsx
























var setUserCarmenData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(setUserLocation) {
        var carmenResponse, msg;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,api/* fetchApiCarmenData */.$3)();
                case 3:
                    carmenResponse = _ctx.sent;
                    if (carmenResponse) {
                        setUserLocation(JSON.stringify(carmenResponse));
                    }
                    _ctx.next = 11;
                    break;
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    msg = "".concat("article-renderer", " was unable to load location from Carmen.");
                    console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    })));
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function setUserCarmenData(setUserLocation) {
        return _ref.apply(this, arguments);
    };
}();
var setUser = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(userLocation, dispatch) {
        var apiUser, userData, msg;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,api/* fetchUser */.BT)();
                case 3:
                    apiUser = _ctx.sent;
                    userData = userLocation ? {
                        location: JSON.parse(userLocation)
                    } : {};
                    dispatch({
                        type: appContextInterfaces/* UserActionTypes.updateUser */.F6.updateUser,
                        payload: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, (apiUser === null || apiUser === void 0 ? void 0 : apiUser.logged_in) && apiUser, userData), {
                            isInitialized: true
                        })
                    });
                    _ctx.next = 12;
                    break;
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    msg = "".concat("article-renderer", " was unable to request the user.");
                    console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
                        error: _ctx.t0
                    })));
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function setUser(userLocation, dispatch) {
        return _ref.apply(this, arguments);
    };
}();
var UserInit = function(param) {
    var children = param.children;
    var user = (0,AppContext/* useAppState */.mr)().user;
    var ref = (0,_sliced_to_array/* default */.Z)(useSessionStorage("user_location"), 2), userLocation = ref[0], setUserLocation = ref[1];
    var appDispatch = (0,AppContext/* useAppDispatch */.TL)();
    react.useEffect(function() {
        setUser(userLocation, appDispatch);
        // NOTE: An email with `themuse.com` does not mean the user is an admin
        var isMuser = (user === null || user === void 0 ? void 0 : user.email) && user.email.split("@")[1] === "themuse.com";
        var _logged_in, _id;
        (0,tracking/* userTrack */.Uk)({
            signed_in: (_logged_in = user.logged_in) !== null && _logged_in !== void 0 ? _logged_in : false,
            is_muser: isMuser,
            is_admin: isMuser,
            user_id: (_id = user.id) !== null && _id !== void 0 ? _id : null
        });
    }, [
        userLocation
    ]);
    react.useEffect(function() {
        setUserCarmenData(setUserLocation);
    }, []);
    react.useEffect(function() {
        appDispatch({
            type: appContextInterfaces/* UserActionTypes.updateUser */.F6.updateUser,
            payload: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, user), {
                location: userLocation ? JSON.parse(userLocation) : user === null || user === void 0 ? void 0 : user.location
            })
        });
    }, [
        userLocation
    ]);
    react.useEffect(function() {
        // NOTE: An email with `themuse.com` does not mean the user is an admin
        var isMuser = (user === null || user === void 0 ? void 0 : user.email) && user.email.split("@")[1] === "themuse.com";
        var ref, ref1;
        (0,tracking/* userTrack */.Uk)({
            signed_in: (ref = user === null || user === void 0 ? void 0 : user.logged_in) !== null && ref !== void 0 ? ref : false,
            is_muser: isMuser,
            is_admin: isMuser,
            user_id: (ref1 = user === null || user === void 0 ? void 0 : user.id) !== null && ref1 !== void 0 ? ref1 : null
        });
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var PageMetaInit = function(param) {
    var children = param.children;
    var pageMetaData = (0,AppContext/* useAppState */.mr)().pageMetaData;
    var appDispatch = (0,AppContext/* useAppDispatch */.TL)();
    react.useEffect(function() {
        var _location = window.location, href = _location.href, search = _location.search;
        var referrer = document.referrer;
        appDispatch({
            type: appContextInterfaces/* PageMetaDataActionTypes.updatePageMetaData */.e9.updatePageMetaData,
            payload: (0,src_object_spread/* default */.Z)({}, pageMetaData, {
                href: href,
                search: search,
                referrer: referrer
            })
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var SnowPlowInit = function() {
    var ref = (0,config["default"])(), snowplowCollector = ref.publicRuntimeConfig.snowplowCollector;
    var ref1 = (0,AppContext/* useAppState */.mr)(), user = ref1.user, _article = ref1.article, sponsor = _article.sponsor, articleId = _article.id;
    var ref2 = (0,react.useState)(false), pageViewTriggered = ref2[0], setPageViewTriggered = ref2[1];
    var companySponsorId = sponsor.legacyId;
    react.useEffect(function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            sp_page_is_external: false,
            sp_page_section: "advice",
            sp_page_sponsor_id: (companySponsorId === null || companySponsorId === void 0 ? void 0 : companySponsorId.toString()) || null,
            sp_page_tab: null,
            sp_page_type: "content",
            sp_page_entity_id: articleId.toString() || null,
            sp_page_entity_uuid: null,
            sp_user_logged_in: user === null || user === void 0 ? void 0 : user.logged_in,
            sp_user_id: user === null || user === void 0 ? void 0 : user.id
        });
        (0,build/* initSnowplowTracker */.Jg)(snowplowCollector);
        (0,build/* trackSnowplowImpressions */.VB)();
        (0,build/* trackSnowplowClicks */.O9)();
        (0,build/* trackSnowplowModalActions */.$N)();
    }, []);
    react.useEffect(function() {
        if (user.isInitialized && !pageViewTriggered) {
            (0,build/* triggerSnowplowPageViewEvent */.y)();
            setPageViewTriggered(true);
        }
    }, [
        user
    ]);
    return null;
};
var __N_SSP = true;
var formatCompanySuggestions = function(companySuggestions) {
    return companySuggestions.slice(0, 4).map(function(companyResult) {
        var text = companyResult.text, value = companyResult.value;
        var short_name = value.short_name; // eslint-disable-line camelcase
        return {
            label: "".concat(text),
            value: "/profiles/".concat(short_name) // eslint-disable-line camelcase
        };
    });
};
var updateInput = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(changes, setItems, setInputValue, fetchData) {
        var inputValue, jobSearchItem, companyResults, companyList;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    inputValue = changes.inputValue;
                    jobSearchItem = {
                        label: "".concat(inputValue),
                        value: "/search/keyword/".concat(inputValue, "/")
                    };
                    setInputValue(inputValue);
                    if (!inputValue) {
                        _ctx.next = 12;
                        break;
                    }
                    setItems([
                        jobSearchItem
                    ]);
                    _ctx.next = 7;
                    return fetchData(inputValue);
                case 7:
                    companyResults = _ctx.sent;
                    companyList = (companyResults === null || companyResults === void 0 ? void 0 : companyResults.length) ? formatCompanySuggestions(companyResults) : [];
                    setItems([
                        jobSearchItem
                    ].concat(companyList));
                    _ctx.next = 13;
                    break;
                case 12:
                    {
                        setItems([]);
                    }
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function updateInput(changes, setItems, setInputValue, fetchData) {
        return _ref.apply(this, arguments);
    };
}();
var Home = function(props) {
    var article = props.article, path = props.path, featureFlags = props.featureFlags;
    var articleUri = article.articleUri, contentAuthor = article.contentAuthor, breadcrumbLinks = article.breadcrumbLinks, dateUpdated = article.dateUpdated, excerpt = article.excerpt, leadMedia = article.leadMedia, postDate = article.postDate, primaryTopic = article.primaryTopic, seo = article.seo, title = article.title;
    var ref = contentAuthor !== null && contentAuthor !== void 0 ? contentAuthor : {}, writerName = ref.writerName, writerUri = ref.writerUri;
    var canonical = getCanonicalUrl(path);
    var description = excerpt;
    var pageMetaData = {
        pathName: path
    };
    var ref1 = (0,react.useState)([]), dropdownItems = ref1[0], setDropdownItems = ref1[1];
    var ref2 = (0,react.useState)(""), inputValue = ref2[0], setInputValue = ref2[1];
    var searchQuerySubmittedEvent = function(selectedItemText) {
        var searchTerm = selectedItemText || inputValue;
        var eventProps = {
            search_term: searchTerm || ""
        };
        (0,tracking/* pushDataLayerEvent */.Jt)("searchQuerySubmitted", eventProps);
    };
    var onKeyboardSelectItem = function(_, selectedItem) {
        if (!(0,browser/* isBrowser */.jU)()) return "";
        var searchPath = inputValue ? "/search/keyword/".concat(inputValue) : "/search";
        var selectPath = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) ? selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value : searchPath;
        searchQuerySubmittedEvent(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label);
        return window.open(selectPath, "_blank").focus();
    };
    var onMouseSelectItem = function(_, selectedItem) {
        searchQuerySubmittedEvent(selectedItem.label);
    };
    var dropdownProps = {
        IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Search */.ol, {}),
        debounceWait: 10,
        dropdownList: dropdownItems,
        inputId: "search-input",
        onInputChange: function(changes) {
            return updateInput(changes, setDropdownItems, setInputValue, api/* fetchCompanySuggestions */.SC);
        },
        noResultsMessage: " ",
        onKeyboardSelectItem: onKeyboardSelectItem,
        onMouseSelectItem: onMouseSelectItem
    };
    var pageLayoutProps = {
        activePath: "/advice",
        headerClassName: (Home_module_default()).pageHeader,
        pageName: (Home_module_default()).pageWrapper,
        mainClassName: (Home_module_default()).main,
        enableCompanySearch: true,
        companySearchDropdownProps: dropdownProps
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsProvider, {
        featureFlags: featureFlags,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppContext/* AppProvider */.wI, {
            article: article,
            pageMetaData: pageMetaData,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO, {
                    articleUri: articleUri,
                    canonical: canonical,
                    breadcrumbLinks: breadcrumbLinks,
                    dateUpdated: dateUpdated,
                    description: description,
                    leadMedia: leadMedia,
                    postDate: postDate,
                    primaryTopic: primaryTopic,
                    seo: seo,
                    title: title,
                    writerName: writerName,
                    writerUri: writerUri
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInit, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMetaInit, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnowPlowInit, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppPageLayout, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pageLayoutProps), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNav, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleContainer, {})
                                ]
                            }))
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 8318:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RecentArticles":"RecentArticles_RecentArticles__B5QOX","RecentArticlesHeading":"RecentArticles_RecentArticlesHeading__x5uJz","RecentTile":"RecentArticles_RecentTile__ifhZu","linkWrapper":"RecentArticles_linkWrapper__NbD0r","image":"RecentArticles_image__XktM6","content":"RecentArticles_content__rlxNo","author":"RecentArticles_author__Py9dH","title":"RecentArticles_title__C6zt5"};

/***/ }),

/***/ 4847:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article":"articleContainer_article__sZv8h","articleContainer":"articleContainer_articleContainer__6hkG4","articleBody":"articleContainer_articleBody__Th07G","articleContent":"articleContainer_articleContent__5tm7S","lastUpdatedDisplay":"articleContainer_lastUpdatedDisplay__XisTK","contentModule":"articleContainer_contentModule__FkpWB","jump-link":"articleContainer_jump-link__NzFWL","twitter-tweet":"articleContainer_twitter-tweet__6PGw5","listicle-header":"articleContainer_listicle-header__0ncgE","articleBannerFlexContainer":"articleContainer_articleBannerFlexContainer__hx5Y_"};

/***/ }),

/***/ 6874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleHeader":"articleHeader_articleHeader__wIhbu","container":"articleHeader_container__kV9q2","breadCrumbLink":"articleHeader_breadCrumbLink__Uv5QC","title":"articleHeader_title__y0ohJ"};

/***/ }),

/***/ 9817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social":"articleSocial_social__W5P_2","articleMetadata":"articleSocial_articleMetadata__LczPT","dataGroup":"articleSocial_dataGroup__jPkL9","metadataField":"articleSocial_metadataField__Ow4B5","metadataData":"articleSocial_metadataData__3lw0M","icon":"articleSocial_icon__jqfQq","facebook":"articleSocial_facebook__jzZFJ","twitter":"articleSocial_twitter__acjFr","linkedin":"articleSocial_linkedin__l7QaV","email":"articleSocial_email__wZ5nb"};

/***/ }),

/***/ 6349:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"author":"authorModule_author__Fmilo","headshot":"authorModule_headshot__vSNLn","bio":"authorModule_bio__tQRc7","readMore":"authorModule_readMore__jHhl9","callToAction":"authorModule_callToAction__k4WxK","icon":"authorModule_icon__cdF9o","richText":"authorModule_richText__l61_v"};

/***/ }),

/***/ 8110:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pullQuote":"blockQuote_pullQuote__7oF4k","quoteMark":"blockQuote_quoteMark__iL2jL","open":"blockQuote_open__cUp3l","close":"blockQuote_close__Prudl","richText":"blockQuote_richText__6wbnv"};

/***/ }),

/***/ 8900:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ctaButtons":"company_ctaButtons__ycUoM","squareButton":"company_squareButton__N_zGS","officeGrid":"company_officeGrid__oebT7","primary":"company_primary__x72ak","secondary":"company_secondary__4t4pu","tertiary":"company_tertiary__IWgHD","description":"company_description__sznTI"};

/***/ }),

/***/ 5886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__L0x8q"};

/***/ }),

/***/ 8747:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"jobsSidebarWrapper":"jobsSidebar_jobsSidebarWrapper__Qlxuw","sidebar":"jobsSidebar_sidebar__JrjOz","jobsSidebar":"jobsSidebar_jobsSidebar__Y6JCJ","container":"jobsSidebar_container__VdoOe","explore":"jobsSidebar_explore__0mast","fullText":"jobsSidebar_fullText__w3Rnh","header":"jobsSidebar_header__h9phe","text":"jobsSidebar_text__nFPFh","typing":"jobsSidebar_typing__6uMmt","blink-caret":"jobsSidebar_blink-caret__18x_j","hotJobs":"jobsSidebar_hotJobs__bs0tU","buttonLink":"jobsSidebar_buttonLink__lRjKP","icon":"jobsSidebar_icon__tPGl4","pin":"jobsSidebar_pin__fl5it","megaphone":"jobsSidebar_megaphone___F2Za","logo":"jobsSidebar_logo__UfePw","iconContainer":"jobsSidebar_iconContainer__m7o5y","searchLocation":"jobsSidebar_searchLocation__pRruZ"};

/***/ }),

/***/ 1111:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"leadMedia":"leadMedia_leadMedia__8deBJ","imageResponsive":"leadMedia_imageResponsive__rC8YL","caption":"leadMedia_caption__Yla9g","button":"leadMedia_button__R5FpS","socialIcon":"leadMedia_socialIcon__S58At","pinterest":"leadMedia_pinterest__XslBa","imagePin":"leadMedia_imagePin__2TshV"};

/***/ }),

/***/ 1536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img":"responsiveImageModule_img__ekXHX","imgResponsive":"responsiveImageModule_imgResponsive__s4ajb","imageWrapper":"responsiveImageModule_imageWrapper__FVEW8","articleBodyImageModule":"responsiveImageModule_articleBodyImageModule__2i_XG","pullleft":"responsiveImageModule_pullleft__a_1ST","pullright":"responsiveImageModule_pullright__cTkDB","pullcenter":"responsiveImageModule_pullcenter__mxOQ2","imageRound":"responsiveImageModule_imageRound__Lv8Ze","fixed-height-container":"responsiveImageModule_fixed-height-container__sRiYZ","infographic":"responsiveImageModule_infographic__F1kw4","caption":"responsiveImageModule_caption__Uckvw"};

/***/ }),

/***/ 1719:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentModule":"sponsorModule_contentModule__hTriF","inline":"sponsorModule_inline__QDcvW","sponsorInlineLogo":"sponsorModule_sponsorInlineLogo__p2IoR","sponsorInlineEyebrow":"sponsorModule_sponsorInlineEyebrow__PfbpF","sponsorInlineTitle":"sponsorModule_sponsorInlineTitle__IiF4t","squareButton":"sponsorModule_squareButton__XcI5Y","logoPill":"sponsorModule_logoPill__glmIQ","midway":"sponsorModule_midway__ibMHN","iconMediaBlock":"sponsorModule_iconMediaBlock__h47UY","sponsor":"sponsorModule_sponsor__J42Ud","frozen":"sponsorModule_frozen___kFRM","logoWrapper":"sponsorModule_logoWrapper__ACTJ1","content":"sponsorModule_content__cmUsL","callToAction":"sponsorModule_callToAction__kTxh4","sidebar":"sponsorModule_sidebar__f0Zft","footer":"sponsorModule_footer__FKyEe","jobsSidebar":"sponsorModule_jobsSidebar__mchfy"};

/***/ }),

/***/ 5649:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sponsoredRecircWidget":"sponsoredRecircWidget_sponsoredRecircWidget__3kXQB","logoPill":"sponsoredRecircWidget_logoPill__HxoSj","container":"sponsoredRecircWidget_container__1J3WP","header":"sponsoredRecircWidget_header__9rQ5A","companyImage":"sponsoredRecircWidget_companyImage__lkcsv","mainContent":"sponsoredRecircWidget_mainContent__mGBok","title":"sponsoredRecircWidget_title__pOIbs","companyName":"sponsoredRecircWidget_companyName__80M_f","footer":"sponsoredRecircWidget_footer__YnSrf","companyProfileCta":"sponsoredRecircWidget_companyProfileCta__0oidS","museLogo":"sponsoredRecircWidget_museLogo___mTNx"};

/***/ }),

/***/ 8621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subNav":"subNav_subNav__Mb_ps","menuItem":"subNav_menuItem__injxa","menuGroup":"subNav_menuGroup__98G3_","menu":"subNav_menu__e8g05","navLink":"subNav_navLink__Qau4l","linkText":"subNav_linkText__FFkzn","mfe-sub-nav__active":"subNav_mfe-sub-nav__active__n0YRf","menuItemNested":"subNav_menuItemNested__X01Og","link":"subNav_link__jQCHH","subNavActive":"subNav_subNavActive__MfznV","title":"subNav_title__zWx5I"};

/***/ }),

/***/ 4865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__zgAJj","pageHeader":"Home_pageHeader__Y8w6l","header":"Home_header__6KCIB","inputMenuOpen":"Home_inputMenuOpen__jnEXa","sidebar":"Home_sidebar__moo8u","showSidebar":"Home_showSidebar__I0bGu Home_sidebar__moo8u","content":"Home_content__f1lUf","filterToggle":"Home_filterToggle__N96mk"};

/***/ }),

/***/ 30:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"callToAction":"common_callToAction__Lw__1","fa-angle-right":"common_fa-angle-right__4bKwF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [970,388,754,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);